import { Asl, ContattoAudit, DiagnosiIcd10 } from './../../model/Models';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { ModalDismissReasons, NgbDateStruct, NgbModal, NgbTypeahead, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../services/api.service';
import {
  Contatto,
  Page,
  Prestazione,
  DettaglioAnagrafica,
  RichiestaPrevalente,
  Inviante,
  Diagnosi,
  PrecedenteContatto,
  ModalitaConclusione,
  Intervento,
  Presenza,
  NotAvailableDatesContainer,
  ConfStato, DiagnosiEScale
} from '../../model/Models';
import { Router } from '@angular/router';
import { SessionService } from '../../services/session.service';
import { TheadColumn } from 'src/app/components/table/thead/thead-column';
import { TableSorter } from 'src/app/components/table/thead/table-sorter';
import { ToastService } from "../../services/toast.service";
import { Funzionalita } from "../../model/Funzionalita";
import { BlockUI, NgBlockUI } from 'ng-block-ui';
	import {
	  debounceTime,
	  distinctUntilChanged,
	  filter,
	  lastValueFrom,
	  map,
	  merge,
	  Observable,
	  OperatorFunction,
	  Subject, Subscription
	} from 'rxjs';
import { emptyDiagnosiValidator, optionalDiagnosiValidator } from 'src/app/util/codicefiscale.validators';
import { dataNonValidaValidator } from '../../util/codicefiscale.validators';
import { Utente } from '../../model/Models';
import { environment } from 'src/environments/environment';
import { CommonsUtil } from "../../util/CommonsUtil";
import {
  StoricoAnagraficaEditComponent
} from "../../components/storico-anagrafica-edit/storico-anagrafica-edit.component";

enum TabShowedState {
  CONTATTI, PRESTAZIONI, INTERVENTI, DIAGNOSISCALE, PRESENZE, ANAGRAFICA
}
@Component({
  selector: 'app-contatto',
  templateUrl: './contatto.component.html',
  styleUrls: ['./contatto.component.css']
})
export class ContattoComponent implements OnInit, OnDestroy {


  minDate = { year: 1920, month: 1, day: 1 };
  maxDate = { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() }

  richiestaDataModel!: NgbDateStruct


  aperturaDataModel!: NgbDateStruct | null;
  minAperturaDateModel!: NgbDateStruct | null;


  minChiusuraDateModel!: any
  chiusuraDataModel!: NgbDateStruct | null;

  contattoForm!: FormGroup

  contattoFormSubmitted = false

  contatto!: Contatto

  page: Page<Prestazione> = new Page<Prestazione>();

  anagraficaOK: boolean = false;

  theadColumns!: TheadColumn[];

  tableSorter: TableSorter = new TableSorter();

  anagrafica: DettaglioAnagrafica = new DettaglioAnagrafica();

  listRichiestePrevalenti: RichiestaPrevalente[] = []

  listInvianti: Inviante[] = []

  listPrecedentiContatti: PrecedenteContatto[] = []

  listDiagnosiApertura: Diagnosi[] = []

  listDiagnosiChiusura: Diagnosi[] = []

  listDiagnosiIcd10: DiagnosiIcd10[] = [] //[ADEGUAMENTO-ICD10][#24]
  suggestedDiagnosiIcd9Apertura: Diagnosi[] = []
  suggestedDiagnosiIcd9Chiusura: Diagnosi[] = []
  private lastIcd10AperturaSuggestionsCode: string | null = null
  private lastIcd10ChiusuraSuggestionsCode: string | null = null
  private lastDiagnosiAperturaIcd10CodeForReset: string | null = null
  private lastDiagnosiChiusuraIcd10CodeForReset: string | null = null

  listaModalitaConclusione: ModalitaConclusione[] = []

  closeResult = ''

  tabShowed?: TabShowedState = TabShowedState.CONTATTI;

  modelAperturaDiagnosi!: any
  modelAperturaDiagnosiIcd10!: DiagnosiIcd10 | string | null;
  modelChiusuraDiagnosiIcd10!: DiagnosiIcd10 | string | null;

  private readonly diagnosiIcd10VisibleFromDate = new Date(2026, 0, 1);
  private diagnosiIcd10RequiredFromDate = this.parseConfigDate(environment.diagnosiIcd10RequiredFromDate) ?? new Date(2026, 3, 1);
  modelChiusuraDiagnosi!: any

  aperturaFlag: string | null = null;

  mainUser!: Utente

  deleteVisible = false

  contattoApertoSetting: Contatto = new Contatto();

  contattoChiusoSetting: Contatto = new Contatto();

  listContatti?: Contatto[]

  listPresenze: Presenza[] = []

  listOfContattiNotAvailableDates: string[] = []

  listOfDiagnosiEScaleNotAvailableDates: string[] = []

  listOfInterventiNotAvailableDates: string[] = []

  listOfPresenzeNotAvailableDates: string[] = []

  listOfPrestazioniNotAvailableDates: string[] = []

  notAvailableDatesContainer$?: NotAvailableDatesContainer

  dateCheck = environment.dateInsertCheck

  enableStatiAttuali: Array<number> = [1, 2, 4, 7, 9, 0];

  confStati: ConfStato[] = [];
  private aslList: Asl[] = [];
  allAnagraficaContatti: Contatto[] = []
  lastDiagnosiEScale: any;
  lastDiagnosiEScaleIcd10Descrizione: string = '';
  presenzeError: boolean = false;
  diagnosiError: boolean = false;
  confermadiagnosichiusuraterritoriale: string = "";

  public messagechangediagnosi: string = "";
  public messageChangeDataChiusuraDiagnosi: string = "";


  @ViewChild('chiudiContatto', { static: true }) chiudiContattoModal: any;

  @ViewChild('confermaChangeDataChiusuraDiagnosi', { static: true }) confermaChangeDataChiusuraDiagnosi: any;

  @ViewChild('strAnaEdit') appStoricoAnagraficaEdit: StoricoAnagraficaEditComponent | undefined;


  // for diagnosi typeahead
  @ViewChild('instance', { static: true }) instance: NgbTypeahead | undefined;
  focus$ = new Subject<string>();
  click$ = new Subject<string>();

  formatter = (diagnosi: Diagnosi) => (diagnosi.codice != undefined ? diagnosi.codice!! + ' - ' + diagnosi.descrizione! : '')

  resultFormatter = (diagnosi: Diagnosi) => (diagnosi.codice != undefined ? diagnosi.codice!! + ' - ' + diagnosi.descrizione! : '');

  diagnosiSearch: OperatorFunction<string, readonly Diagnosi[]> = (textApertura$: Observable<string>) => {
    const debouncedText$ = textApertura$.pipe(debounceTime(200), distinctUntilChanged());
    const clicksWithClosedPopup$ = this.click$.pipe(filter(() => !this.instance?.isPopupOpen()));
    const inputFocus$ = this.focus$;

    return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
      map((term: string) => this.mergeDiagnosiIcd9Results(term, true))
    )
  }

  /**
   * //[ADEGUAMENTO-ICD10][#24]
   * Formatter per la diagnosi icd10
   *
   * @lastUpdate 2026-02-03 - Alessio Scoppetta
   * @description Formatter per la diagnosi icd10
   */
  formatterIcd10 = (diagnosi: DiagnosiIcd10) => (diagnosi.codice != undefined ? diagnosi.codice!! + ' - ' + diagnosi.descrizione! : '')


  /**
   * //[ADEGUAMENTO-ICD10][#24]
   * Result formatter per la diagnosi icd10
   * @lastUpdate 2026-02-03 - Alessio Scoppetta
   *
   */
  resultFormatterIcd10 = (diagnosi: DiagnosiIcd10) => (diagnosi.codice != undefined ? diagnosi.codice!! + ' - ' + diagnosi.descrizione! : '');

  /**
   * //[ADEGUAMENTO-ICD10][#24]
   * Operatore di ricerca per la diagnosi icd10
   * @lastUpdate 2026-02-03 - Alessio Scoppetta
   */
  diagnosiSearchIcd10: OperatorFunction<string, readonly DiagnosiIcd10[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term: string) => term.length < 2 ? []
        : this.listDiagnosiIcd10
          .filter(v =>
            v && v.descrizione && v.descrizione.toLowerCase().indexOf(term.toLowerCase()) > -1
            || v && v.codice && v.codice.toLowerCase().indexOf(term.toLowerCase()) > -1
          ))
	    )

  private resolveDiagnosiIcd10Model(model: DiagnosiIcd10 | string | null | undefined): DiagnosiIcd10 | null {
    if (model == null) {
      return null;
    }

    if (typeof model === 'string') {
      const term = model.trim();
      if (!term) {
        return null;
      }
      const codice = term.split(' - ')[0].trim();
      const found = this.listDiagnosiIcd10?.find(d => d?.codice?.toLowerCase() === codice.toLowerCase());
      return found ?? null;
    }

    if (model.codice != null && model.codice.trim() !== '') {
      return model;
    }

    return null;
  }

  private isDiagnosiIcd10Required(): boolean {
    if (!this.showDiagnosiIcd10()) return false;
    // CHANGE REQUEST PRE-RILASCIO:
    // l'unica ASL in sperimentazione per ICD10 e' 109 (Viterbo).
    // Se in futuro dovranno essere abilitate altre ASL, andranno cablate esplicitamente qui.
    if (!this.mainUser || this.mainUser.codiceAsl !== "109") return false;
    if (!this.aperturaDataModel) return false;
    const apertura = this.sessionSevice.toNativeDate(this.aperturaDataModel);
    if (!apertura) return false;
    return this.isSameOrAfterDay(apertura, this.diagnosiIcd10RequiredFromDate);
  }

  isDiagnosiAperturaIcd10RequiredLabel(): boolean {
    return this.isDiagnosiIcd10Required();
  }

  isDiagnosiChiusuraIcd10RequiredLabel(): boolean {
    return this.chiusuraDataModel != null && this.isDiagnosiIcd10Required();
  }

  /**
   * [ADEGUAMENTO-ICD10][TASK#49 - controllo incrociato diagnosi apertura e chiusura]
   *
   * @lastUpdate 2026-03-19 - Alessio Scoppetta
  */
  private hasDiagnosiIcd10Selection(apertura: boolean): boolean {
    const controlName = apertura ? 'diagnosiAperturaIcd10' : 'diagnosiChiusuraIcd10';
    const model = this.contattoForm?.get(controlName)?.value
      ?? (apertura ? this.modelAperturaDiagnosiIcd10 : this.modelChiusuraDiagnosiIcd10);
    return this.resolveDiagnosiIcd10Model(model) != null;
  }

  hasDiagnosiIcd10PairError(apertura: boolean): boolean {
    const controlName = apertura ? 'diagnosiAperturaIcd10' : 'diagnosiChiusuraIcd10';
    return !!this.contattoForm?.get(controlName)?.hasError('icd10PairRequired');
  }

  private clearDiagnosiIcd10State(): void {
    this.modelAperturaDiagnosiIcd10 = null;
    this.modelChiusuraDiagnosiIcd10 = null;
    this.lastDiagnosiAperturaIcd10CodeForReset = null;
    this.lastDiagnosiChiusuraIcd10CodeForReset = null;
    this.suggestedDiagnosiIcd9Apertura = [];
    this.suggestedDiagnosiIcd9Chiusura = [];
    this.lastIcd10AperturaSuggestionsCode = null;
    this.lastIcd10ChiusuraSuggestionsCode = null;
    this.contattoForm?.get('diagnosiAperturaIcd10')?.setValue(null, { emitEvent: false });
    this.contattoForm?.get('diagnosiChiusuraIcd10')?.setValue(null, { emitEvent: false });
  }

  isDiagnosiIcd10Locked(): boolean {
    const apertura = this.aperturaDataModel
      ? this.sessionSevice.toNativeDate(this.aperturaDataModel)
      : (this.contatto?.dataApertura ? new Date(this.contatto.dataApertura as any) : null);
    if (!apertura) return true;
    return !this.isSameOrAfterDay(apertura, this.diagnosiIcd10VisibleFromDate);
  }

  /**
   * //[CHANGE-REQUEST][PRE-RILASCIO]
   * Mostra la notina informativa su Diagnosi ICD10 solo ai profili con permesso di scrittura.
   * @lastUpdate 2026-03-11 - Alessio Scoppetta
   * @author Alessio Scoppetta
   */
  canShowDiagnosiIcd10Info(): boolean {
    return this.hasWritePermission(this.mainUser);
  }

  /**
   * //[CHANGE-REQUEST][PRE-RILASCIO]
   * Restituisce il testo informativo sulla data di obbligatorieta' della Diagnosi ICD10
   * leggendo la soglia configurata da property di sistema.
   * @lastUpdate 2026-03-11 - Alessio Scoppetta
   * @author Alessio Scoppetta
   */
  getDiagnosiIcd10InfoTooltip(): string {
    return `Il campo Diagnosi ICD10 e' obbligatorio per le strutture in sperimentazione per i soli contatti avviati a partire dal ${this.formatDiagnosiIcd10RequiredDate()}. E' facoltativo per le altre strutture.`;
  }

  getDiagnosiIcd9InfoTooltip(): string {
    return "Valorizzando il campo Diagnosi ICD10 e cliccando nel campo Diagnosi ICD9 sara' possibile visionare una lista delle Diagnosi ICD9, corrispondenti al codice ICD10 inserito, suggerite dal Ministero della Salute. E' possibile selezionare una voce dal menu proposto oppure digitare una Diagnosi ICD9 alternativa, purche' tra le diagnosi ammissibili ICD9 previste da SISTeP.";
  }

  /**
   * //[CHANGE-REQUEST][PRE-RILASCIO]
   * Format della data di obbligatorieta' ICD10 per la visualizzazione nella notina informativa.
   * @lastUpdate 2026-03-11 - Alessio Scoppetta
   * @author Alessio Scoppetta
   */
  private formatDiagnosiIcd10RequiredDate(): string {
    const d = this.diagnosiIcd10RequiredFromDate;
    const day = `${d.getDate()}`.padStart(2, '0');
    const month = `${d.getMonth() + 1}`.padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  }

  private refreshDiagnosiIcd10Validators(): void {
    if (!this.contattoForm) return;

    const aperturaCtrl = this.contattoForm.get('diagnosiAperturaIcd10');
    const chiusuraCtrl = this.contattoForm.get('diagnosiChiusuraIcd10');
    const shouldValidateIcd10Pair = this.chiusuraDataModel != null;

    if (!aperturaCtrl || !chiusuraCtrl) return;

    if (this.isDiagnosiIcd10Locked()) {
      this.clearDiagnosiIcd10State();
      aperturaCtrl.clearValidators();
      chiusuraCtrl.clearValidators();
      aperturaCtrl.updateValueAndValidity({ onlySelf: true, emitEvent: false });
      chiusuraCtrl.updateValueAndValidity({ onlySelf: true, emitEvent: false });
      return;
    }

    const aperturaValidators = [optionalDiagnosiValidator(), () => {
      if (!shouldValidateIcd10Pair) return null;
      if (!this.hasDiagnosiIcd10Selection(false)) return null;
      return this.hasDiagnosiIcd10Selection(true) ? null : { icd10PairRequired: true };
    }];
    if (this.isDiagnosiIcd10Required()) {
      aperturaValidators.unshift(Validators.required);
    }
    aperturaCtrl.setValidators(aperturaValidators);
    aperturaCtrl.updateValueAndValidity({ onlySelf: true, emitEvent: false });

    const chiusuraValidators = [optionalDiagnosiValidator(), () => {
      if (!shouldValidateIcd10Pair) return null;
      if (!this.hasDiagnosiIcd10Selection(true)) return null;
      return this.hasDiagnosiIcd10Selection(false) ? null : { icd10PairRequired: true };
    }];
    const chiusuraRequired = this.chiusuraDataModel != null && this.isDiagnosiIcd10Required();
    if (chiusuraRequired) {
      chiusuraValidators.unshift(Validators.required);
    }
    chiusuraCtrl.setValidators(chiusuraValidators);
    chiusuraCtrl.updateValueAndValidity({ onlySelf: true, emitEvent: false });
  }

  private refreshIcd9SuggestionsFromIcd10(apertura: boolean): void {
    if (!this.showDiagnosiIcd10()) {
      if (apertura) this.suggestedDiagnosiIcd9Apertura = []
      else this.suggestedDiagnosiIcd9Chiusura = []
      return;
    }

    const ctrlName = apertura ? 'diagnosiAperturaIcd10' : 'diagnosiChiusuraIcd10'
    const model = this.contattoForm?.get(ctrlName)?.value ?? (apertura ? this.modelAperturaDiagnosiIcd10 : this.modelChiusuraDiagnosiIcd10)
    const resolved = this.resolveDiagnosiIcd10Model(model)
    const codiceIcd10 = resolved?.codice?.trim() ? resolved.codice.trim() : null

    if (!codiceIcd10) {
      if (apertura) {
        this.lastIcd10AperturaSuggestionsCode = null
        this.suggestedDiagnosiIcd9Apertura = []
      } else {
        this.lastIcd10ChiusuraSuggestionsCode = null
        this.suggestedDiagnosiIcd9Chiusura = []
      }
      return
	    }

	    if (apertura) {
	      if (this.lastIcd10AperturaSuggestionsCode === codiceIcd10 && this.suggestedDiagnosiIcd9Apertura.length > 0) return
	      this.lastIcd10AperturaSuggestionsCode = codiceIcd10
	    } else {
	      if (this.lastIcd10ChiusuraSuggestionsCode === codiceIcd10 && this.suggestedDiagnosiIcd9Chiusura.length > 0) return
	      this.lastIcd10ChiusuraSuggestionsCode = codiceIcd10
	    }

    this.apiService.getIcd9SuggestionsByIcd10(codiceIcd10).subscribe({
      next: (res) => {
        const list = res ?? []
        if (apertura) this.suggestedDiagnosiIcd9Apertura = list
        else this.suggestedDiagnosiIcd9Chiusura = list
      },
      error: () => {
        if (apertura) this.suggestedDiagnosiIcd9Apertura = []
        else this.suggestedDiagnosiIcd9Chiusura = []
      }
    })
  }

  applySuggestedDiagnosiIcd9(diagnosi: Diagnosi, apertura: boolean): void {
    if (!diagnosi) return
    if (apertura) {
      this.modelAperturaDiagnosi = diagnosi
      this.contattoForm.get('diagnosiApertura')?.setValue(diagnosi, { emitEvent: false })
      this.contattoForm.get('diagnosiApertura')?.markAsDirty()
      this.contattoForm.get('diagnosiApertura')?.updateValueAndValidity({ onlySelf: true })
    } else {
      this.modelChiusuraDiagnosi = diagnosi
      this.contattoForm.get('diagnosiChiusura')?.setValue(diagnosi, { emitEvent: false })
      this.contattoForm.get('diagnosiChiusura')?.markAsDirty()
      this.contattoForm.get('diagnosiChiusura')?.updateValueAndValidity({ onlySelf: true })
    }
  }

  private getDiagnosiIcd10Code(model: DiagnosiIcd10 | string | null | undefined): string | null {
    const resolved = this.resolveDiagnosiIcd10Model(model);
    const code = resolved?.codice?.trim();
    return code ? code : null;
  }

  private resetIcd9IfIcd10Changed(apertura: boolean, currentIcd10Code: string | null): void {
    const previousCode = apertura
      ? this.lastDiagnosiAperturaIcd10CodeForReset
      : this.lastDiagnosiChiusuraIcd10CodeForReset;

    const hasChanged = !!currentIcd10Code && currentIcd10Code !== previousCode;

    if (hasChanged) {
      if (apertura) {
        const hasIcd9Value = !!this.modelAperturaDiagnosi?.codice || !!this.contattoForm.get('diagnosiApertura')?.value;
        if (hasIcd9Value) {
          this.modelAperturaDiagnosi = null;
          this.contattoForm.get('diagnosiApertura')?.setValue(null, { emitEvent: false });
          this.contattoForm.get('diagnosiApertura')?.markAsDirty();
          this.contattoForm.get('diagnosiApertura')?.updateValueAndValidity({ onlySelf: true });
        }
      } else {
        const hasIcd9Value = !!this.modelChiusuraDiagnosi?.codice || !!this.contattoForm.get('diagnosiChiusura')?.value;
        if (hasIcd9Value) {
          this.modelChiusuraDiagnosi = null;
          this.contattoForm.get('diagnosiChiusura')?.setValue(null, { emitEvent: false });
          this.contattoForm.get('diagnosiChiusura')?.markAsDirty();
          this.contattoForm.get('diagnosiChiusura')?.updateValueAndValidity({ onlySelf: true });
        }
      }
    }

    if (apertura) this.lastDiagnosiAperturaIcd10CodeForReset = currentIcd10Code;
    else this.lastDiagnosiChiusuraIcd10CodeForReset = currentIcd10Code;
  }

  // Ripristino modale informativa al cambio diagnosi (Diagnosi&Scale verrà aggiornato)
  onDiagnosiIcd9Selected(event: NgbTypeaheadSelectItemEvent, apertura: boolean, confermachangediagnosi: any): void {
    const diagnosi = event.item as Diagnosi;
    if (!diagnosi) return;

    if (apertura) {
      this.modelAperturaDiagnosi = diagnosi;
      this.contattoForm.get('diagnosiApertura')?.setValue(diagnosi, { emitEvent: false });
      this.contattoForm.get('diagnosiApertura')?.markAsDirty();
      this.contattoForm.get('diagnosiApertura')?.updateValueAndValidity({ onlySelf: true });
    } else {
      this.modelChiusuraDiagnosi = diagnosi;
      this.contattoForm.get('diagnosiChiusura')?.setValue(diagnosi, { emitEvent: false });
      this.contattoForm.get('diagnosiChiusura')?.markAsDirty();
      this.contattoForm.get('diagnosiChiusura')?.updateValueAndValidity({ onlySelf: true });
    }

    this.changeDiagnosi(confermachangediagnosi, apertura);
  }

  onDiagnosiIcd10Selected(event: NgbTypeaheadSelectItemEvent, apertura: boolean, confermachangediagnosi: any): void {
    const diagnosi = event.item as DiagnosiIcd10;
    if (!diagnosi) return;
    const nextCode = this.getDiagnosiIcd10Code(diagnosi);

    if (apertura) {
      this.modelAperturaDiagnosiIcd10 = diagnosi;
      this.contattoForm.get('diagnosiAperturaIcd10')?.setValue(diagnosi, { emitEvent: false });
      this.contattoForm.get('diagnosiAperturaIcd10')?.markAsDirty();
      this.contattoForm.get('diagnosiAperturaIcd10')?.updateValueAndValidity({ onlySelf: true });
      this.resetIcd9IfIcd10Changed(true, nextCode);
      // non emetto eventi: refresh manuale suggerimenti ICD9
      this.refreshIcd9SuggestionsFromIcd10(true);
    } else {
      this.modelChiusuraDiagnosiIcd10 = diagnosi;
      this.contattoForm.get('diagnosiChiusuraIcd10')?.setValue(diagnosi, { emitEvent: false });
      this.contattoForm.get('diagnosiChiusuraIcd10')?.markAsDirty();
      this.contattoForm.get('diagnosiChiusuraIcd10')?.updateValueAndValidity({ onlySelf: true });
      this.resetIcd9IfIcd10Changed(false, nextCode);
      this.refreshIcd9SuggestionsFromIcd10(false);
    }

    // stessa modale informativa anche per ICD10 (senza toccare logiche di salvataggio)
    this.changeDiagnosi(confermachangediagnosi, apertura);
  }

  private mergeDiagnosiIcd9Results(term: string, apertura: boolean): Diagnosi[] {
    const normalizedTerm = (term ?? '').toLowerCase();
    const suggestions = apertura ? (this.suggestedDiagnosiIcd9Apertura ?? []) : (this.suggestedDiagnosiIcd9Chiusura ?? []);
    const source = apertura ? this.listDiagnosiApertura : this.listDiagnosiChiusura;

    // richiesto: se ICD10 è selezionata e ci sono suggerimenti, al focus/click mostra i suggeriti (anche se term è vuoto o < 2)
    if (this.showDiagnosiIcd10() && suggestions.length > 0) {
      if (!normalizedTerm || normalizedTerm.length < 2) {
        return suggestions;
      }
      const matches = source.filter(v =>
        v && v.descrizione && v.descrizione.toLowerCase().indexOf(normalizedTerm) > -1
        || v && v.codice && v.codice.toLowerCase().indexOf(normalizedTerm) > -1
      );
      const matchCodes = new Set(matches.map(m => (m?.codice ?? '').toLowerCase()));
      const suggestedNotInMatches = suggestions.filter(s => !matchCodes.has((s?.codice ?? '').toLowerCase()));
      // richiesto: suggeriti sotto i risultati trovati digitando
      return matches.concat(suggestedNotInMatches);
    }

    // comportamento storico (senza suggerimenti): niente risultati finché non si digitano almeno 2 caratteri
    if (!normalizedTerm || normalizedTerm.length < 2) return [];
    return source.filter(v =>
      v && v.descrizione && v.descrizione.toLowerCase().indexOf(normalizedTerm) > -1
      || v && v.codice && v.codice.toLowerCase().indexOf(normalizedTerm) > -1
    );
  }

  private loadDiagnosiIcd10RequiredDate(): void {
    this.apiService.getDataDiagnosiIcd10Config().subscribe({
      next: (dateValue: string) => {
        const parsedDate = this.parseConfigDate(dateValue);
        if (parsedDate) {
          this.diagnosiIcd10RequiredFromDate = parsedDate;
          this.refreshDiagnosiIcd10Validators();
        }
      },
      error: () => {
        // Mantiene il fallback locale se la config non e' disponibile.
      }
    });
  }

  private parseConfigDate(dateValue: string | null | undefined): Date | null {
    const rawValue = (dateValue ?? '').toString().trim();
    if (!rawValue) return null;

    const parts = rawValue.split('-').map(Number);
    if (parts.length !== 3 || parts.some(Number.isNaN)) {
      return null;
    }

    return new Date(parts[0], parts[1] - 1, parts[2]);
  }


  @ViewChild('instanceChiusura', { static: true }) instanceChiusura: NgbTypeahead | undefined;
  focusChiusura$ = new Subject<string>();
  clickChiusura$ = new Subject<string>();

  chiusuraformatter = (diagnosi: Diagnosi) => (diagnosi.codice != '' ? diagnosi.codice!! + ' - ' + diagnosi.descrizione! : '');

  resultChiusuraformatter = (diagnosi: Diagnosi) => (diagnosi.codice != '' ? diagnosi.codice!! + ' - ' + diagnosi.descrizione! : '');

  diagnosiChiusuraSearch: OperatorFunction<string, readonly Diagnosi[]> = (textChiusura$: Observable<string>) => {
    const debouncedText$ = textChiusura$.pipe(debounceTime(200), distinctUntilChanged());
    const clicksWithClosedPopup$ = this.clickChiusura$.pipe(filter(() => !this.instanceChiusura?.isPopupOpen()));
    const inputFocus$ = this.focusChiusura$;

    return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
      map((term: string) => this.mergeDiagnosiIcd9Results(term, false))
    )
  }


  @BlockUI()
  blockUI!: NgBlockUI;
  public interventiError: boolean = false;
  public chiudiContattoMode: string | undefined;
  private subscribe1: Subscription | undefined;
  private subscribe2: Subscription | undefined;


  constructor(private apiService: ApiService,
    public toastService: ToastService,
    private sessionSevice: SessionService,
    private fb: FormBuilder,
    private router: Router,
    private modalService: NgbModal) {

  }


  async ngOnInit(): Promise<void> {
    this.loadDiagnosiIcd10RequiredDate()
    this.loadUser()

    this.loadTab()

    this.loadAnagrafica()

    this.loadContatto()

    await this.getAllPrecedentiContatti();
    await this.getAllModalitaConclusione();
    await this.getRichiestePrevalenti()
    await this.getDiagnosi();
    await this.getDiagnosiIcd10(); //[ADEGUAMENTO-ICD10][#24]

    this.loadTable(this.contatto)

    await this.initContattoForm()

    if (!this.isFormTerritoriale()) {
      await this.getInviantiSemiResidenziali()
      this.aperturaFlag = "1"
    } else {
      await this.getInviantiTerritoriali()
    }

    // se contatto non e nuovo puo avere figli
    if (!this.contattoIsNew(this.contatto)) {
      this.loadPresenze(this.contatto)
    }

    this.loadPrestazioni(this.contatto.id!!, 0, this.page.size, null, null)


    this.contattoForm.markAsPristine()

    this.setValidatorsBasedOnFlag(this.aperturaFlag)

    this.observeForDataRefresh()

    this.observeStrutturaChange();
    this.observeDataRichiestaChange();
    this.observeDataAperturaChange();
    this.observeDataChiusuraChange();
    this.dataChiusuraExist();
    this.limitMaxDate();
    this.loadContatti();

    this.apiService.getAllConfStato().subscribe(data => {
      if (data) {
        this.confStati = data;
      }
    })
    this.apiService.getAllAsl().subscribe(data => {
      for (let item of data) {
        if (item.codiceAzienda != "98" && item.codiceAzienda != "098" && item.codiceAzienda != "998" && item.codiceAzienda != "999") {
          this.aslList.push(item);
        }
      }
    });
    this.loadHasOpenContattiStatus(this.anagrafica);
  }

  observeDataChiusuraChange() {
    this.contattoForm.get('dataChiusura')?.valueChanges.subscribe(date => {
      this.chiusuraDataModel = date;
      if (date == null) {
        this.contattoForm.get('modalitaConclusione')?.removeValidators([Validators.required])
        this.contattoForm.get('diagnosiChiusura')?.removeValidators([Validators.required])
      } else {
        this.contattoForm.get('modalitaConclusione')?.addValidators([Validators.required])
        this.contattoForm.get('diagnosiChiusura')?.addValidators([Validators.required])

      }
      this.contattoForm.controls['modalitaConclusione'].updateValueAndValidity();
      this.contattoForm.controls['diagnosiChiusura'].updateValueAndValidity();
      this.refreshDiagnosiIcd10Validators();
    })
  }

  observeDataRichiestaChange() {
    this.contattoForm.get('dataRichiesta')?.valueChanges.subscribe(date => {
      this.richiestaDataModel = date;
      this.refreshDataRichiestaVisibility();
    });
  }

  observeDataAperturaChange() {
    this.contattoForm.get('dataApertura')?.valueChanges.subscribe(date => {
      this.aperturaDataModel = date;
      this.refreshDataRichiestaVisibility();
      this.refreshDiagnosiIcd10Validators();
    });
  }

  observeStrutturaChange() {
    this.sessionSevice.strutturaChanged.subscribe(res => {
      if (res) {
        this.router.navigate(['ricerca-anagrafica'])
      }
    })
  }

  loadAnagrafica() {

    this.sessionSevice.selectedAnagrafica.subscribe(res => {
      if (res && res != "" && res != null && res != undefined) {
        this.anagrafica = JSON.parse(res);
        // this.loadListOfNotavailableDatesForContatti()

        if (this.anagrafica && this.anagrafica.id) {
          this.apiService.getContattoApertoSetting(this.anagrafica!.id!,
            (this.sessionSevice.isSelectedStrutturaFromStorageTerritoriale() ? "Territoriale" : "Semiresidenziale"))
            .subscribe(res => {
              this.contattoApertoSetting = res
            });
          this.apiService.getContattoChiusoSetting(this.anagrafica!.id!,
            (this.sessionSevice.isSelectedStrutturaFromStorageTerritoriale() ? "Territoriale" : "Semiresidenziale"))
            .subscribe(res => {
              this.contattoChiusoSetting = res
            });
        } else {
          this.leaveEmptyPage()
        }
      } else {
        this.leaveEmptyPage()
      }

    })
  }

  loadTable(contatto: Contatto) {
    let res: TheadColumn[] = [];
    res.push(new TheadColumn('', 'Alert'));
    res.push(new TheadColumn('id', 'IDPrestazione'));
    res.push(new TheadColumn('codiceStrutturaOperatoreInserimento', 'Codice - Denom. Struttura - ASL'));
    res.push(new TheadColumn('contatto.dataApertura', 'Data apertura contatto'));
    res.push(new TheadColumn('dataPrestazione', 'Data prestazione'));
    res.push(new TheadColumn('tipo', 'Tipo prestazione'));
    res.push(new TheadColumn('statoAttuale', 'Stato trasmissione'));


    this.theadColumns = res;

  }

  loadContatto() {
    this.subscribe2 = this.sessionSevice.selectedContatto.subscribe(res => {
      if (res != undefined && res != null) {
        this.contatto = res
        if (this.contattoIsNew(this.contatto)) {
          //this.tabShowed = TabShowedState.ANAGRAFICA;

          this.contatto.tipoPrestazione = this.sessionSevice.isSelectedStrutturaFromStorageTerritoriale() ? "Territoriale" : "Semiresidenziale";
          this.aperturaFlag = null;
        } else {
          this.aperturaFlag = this.contatto.aperturaFlag!!
          this.loadListOfNotavailableDatesForContatti();
        }

      } else {
        this.leaveEmptyPage()
      }
    })

    if (!this.contattoIsNew(this.contatto)) {

      this.apiService.selectContattoById(this.contatto.id!!).subscribe({
        next: (res) => {
          this.contatto = res
          this.sessionSevice.setSelectedContatto(this.contatto)

        },
        error: (err) => {
          console.error(err);
        }
      })
    }

  }

  descrizioneStato(stato: number) {

    for (let confStato of this.confStati) {

      if (stato == 5 && !this.getRuolo(this.OPERATORE_REGIONE))
        stato = 3;

      if (stato == confStato.id) {

        return confStato.descrizione;

      }

    }
    return "Stato non trovato";
  }

  mustDisableForm() {
    if (this.contatto.statoAttuale.id && this.contatto.statoAttuale.id >= 0) {
      return this.enableStatiAttuali.indexOf(this.contatto.statoAttuale.id) == -1
    }
    return false;
  }

  // Modificato MC 10/04/2025
  mustDisableCancelBtn() {
    if (this.contatto.statoAttuale.id >= 0) {
      let statiAttuali: Array<number> = [0, 1, 2, 4, 7, 9];
      return statiAttuali.indexOf(this.contatto.statoAttuale.id) == -1
    }
    return true;
  }

  canClose() {
    if (this.contatto.id) {
      if (this.contatto.dataChiusura === null || this.isNotContattoValidato()) {
        return true;
      } else if (this.contatto.statoAttuale.id == 3 || this.contatto.statoAttuale.id == 5 || this.contatto.statoAttuale.id == 6 || this.contatto.statoAttuale.id == 8) {
        return false;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  canEdit() {
    if (this.contatto.id) {
      if (this.contatto.statoAttuale.id == 3 || this.contatto.statoAttuale.id == 5 || this.contatto.statoAttuale.id == 6 || this.contatto.statoAttuale.id == 8) {
        return false;
      } else if (this.contatto.dataChiusura === null || this.isNotContattoValidato()) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  isNotContattoValidato(): boolean {

    if (this.contatto.statoAttuale && this.contatto.statoAttuale.id >= 0) {

      return this.enableStatiAttuali.indexOf(this.contatto.statoAttuale.id) != -1

    } else {

      return false

    }

  }

  loadUser() {
    this.mainUser = this.sessionSevice.getUtenteFromStorage()!!
  }

  async loadListOfNotavailableDatesForContatti() {
    if (this.dateCheck) {
      let formType = ""
      if (this.isFormTerritoriale()) {
        formType = 'territoriale'
      } else {
        formType = "semiresidenziale"
      }

      if (this.contatto) {
        if (this.contatto.id) {
          this.notAvailableDatesContainer$ = await (this.apiService.getAllContattoNotAvailabeDates(formType,
            this.contatto.id))
          await this.setUnavailableDates(this.notAvailableDatesContainer$)
        }
      } else {
        console.error(this.contatto)
        console.error('questa cosa non dovrebbe mai accadere');
        //alert("Attrnzione si è verificato un errore sul server");
      }
    } else {
      console.log("date check false ..dev mode");
    }
  }


  async setUnavailableDates(notAvailableDatesContainer$: NotAvailableDatesContainer) {

    notAvailableDatesContainer$.contattiDates?.forEach(dt => {

      this.listOfContattiNotAvailableDates.push(JSON.stringify(this.sessionSevice.convertToDateStruct(new Date(dt))))

    })

    this.sessionSevice.setContattiDataNotAvailableList(this.listOfContattiNotAvailableDates)

    notAvailableDatesContainer$.interventiDates?.forEach(dt => {

      this.listOfInterventiNotAvailableDates.push(JSON.stringify(this.sessionSevice.convertToDateStruct(new Date(dt))))

    })

    this.sessionSevice.setInterventiDataNotAvailableList(this.listOfInterventiNotAvailableDates)

    notAvailableDatesContainer$.presenzeDates?.forEach(dt => {

      this.listOfPresenzeNotAvailableDates.push(JSON.stringify(this.sessionSevice.convertToDateStruct(new Date(dt))))

    })

    this.sessionSevice.setPresenzeDataNotAvailableList(this.listOfPresenzeNotAvailableDates)

    notAvailableDatesContainer$.diagnosiEScaleDates?.forEach(dt => {

      this.listOfDiagnosiEScaleNotAvailableDates.push(JSON.stringify(this.sessionSevice.convertToDateStruct(new Date(dt))))

    })

    this.sessionSevice.setDIagnosiEscaleDataNotAvailableList(this.listOfDiagnosiEScaleNotAvailableDates)

    notAvailableDatesContainer$.prestazioniDates?.forEach(dt => {

      this.listOfPrestazioniNotAvailableDates.push(JSON.stringify(this.sessionSevice.convertToDateStruct(new Date(dt))))

    })
    this.sessionSevice.setPrestazioniDataNotAvailableList(this.listOfPrestazioniNotAvailableDates)
    await this.delay(1000);
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  isContattoSemiResideziale(tipoPrestazione: string): boolean {
    if (tipoPrestazione === "Semiresidenziale") {
      return true
    } else {
      return false
    }
  }

  leaveEmptyPage() {
    this.router.navigate(['ricerca-anagrafica'])
  }

  getTitleName(): string {
    if (this.anagrafica.nome === "") {
      return "Nuovo Contatto"
    } else {
      return "" + this.anagrafica.cognome + " " + this.anagrafica.nome + ' (CF: ' + this.anagrafica.codiceFiscale + ")"
    }
  }


  async initContattoForm() {
    if (!this.contattoIsNew(this.contatto)) {
      this.setDateModels(this.contatto)
    }

    // set apertura diagnosi
    this.modelAperturaDiagnosi = new Diagnosi()
    this.modelAperturaDiagnosi.codice = this.contatto.codiceDiagnosiApertura;
    this.modelAperturaDiagnosi.descrizione = this.contatto.descrizioneDiagnosiApertura

    this.modelAperturaDiagnosiIcd10 = null
    if (this.contatto.codiceDiagnosiAperturaIcd10
      && this.contatto.codiceDiagnosiAperturaIcd10.toString().trim() !== '') {
      console.log("Entro in codiceDiagnosiAperturaIcd10 ")
      const diag = new DiagnosiIcd10()
      diag.codice = this.contatto.codiceDiagnosiAperturaIcd10
      diag.descrizione = await this.getDiagnosiIcd10NameByCodice(diag.codice)
      this.modelAperturaDiagnosiIcd10 = diag
    }

    /**
     * SET CHIUSURA DIAGNOSI
     * [ADEGUAMENTO-ICD10][#24]
     *
     * @lastUpdate 2026-02-03 - Alessio Scoppetta
     *
     */
    this.modelChiusuraDiagnosiIcd10 = null
    if (this.contatto.codiceDiagnosiChiusuraIcd10
      && this.contatto.codiceDiagnosiChiusuraIcd10.toString().trim() !== '') {
      const diag = new DiagnosiIcd10()
      diag.codice = this.contatto.codiceDiagnosiChiusuraIcd10
      diag.descrizione = await this.getDiagnosiIcd10NameByCodice(diag.codice)
      this.modelChiusuraDiagnosiIcd10 = diag
    }

    this.contattoForm = this.fb.group({
      dataRichiesta: new FormControl(this.richiestaDataModel, [Validators.required, dataNonValidaValidator()]),
      richiestaPrev: new FormControl(this.contatto.richiestaPrev, [Validators.required]),
      aperturaFlag: new FormControl(this.aperturaFlag,),
      dataApertura: new FormControl(this.aperturaDataModel, [Validators.required, dataNonValidaValidator()]),
      diagnosiApertura: new FormControl("", [Validators.required, emptyDiagnosiValidator()]),
      diagnosiAperturaIcd10: new FormControl(null),
      precedentiContatti: new FormControl(this.contatto.precedentiContatti, [Validators.required]),
      inviante: new FormControl(this.contatto.inviante, [Validators.required]),
      dataChiusura: new FormControl(this.chiusuraDataModel),
      diagnosiChiusura: new FormControl(this.contatto.codiceDiagnosiChiusura),
      diagnosiChiusuraIcd10: new FormControl(null),
      modalitaConclusione: new FormControl(this.contatto.modalitaConclusione)
    });

    this.contattoForm.get('diagnosiAperturaIcd10')?.setValue(this.modelAperturaDiagnosiIcd10, { emitEvent: false });
    this.contattoForm.get('diagnosiChiusuraIcd10')?.setValue(this.modelChiusuraDiagnosiIcd10, { emitEvent: false });
    this.lastDiagnosiAperturaIcd10CodeForReset = this.getDiagnosiIcd10Code(this.modelAperturaDiagnosiIcd10);
    this.lastDiagnosiChiusuraIcd10CodeForReset = this.getDiagnosiIcd10Code(this.modelChiusuraDiagnosiIcd10);
    this.refreshDataRichiestaVisibility();
    this.refreshDiagnosiIcd10Validators();
    this.refreshIcd9SuggestionsFromIcd10(true);
    this.refreshIcd9SuggestionsFromIcd10(false);

    this.contattoForm.get('diagnosiAperturaIcd10')?.valueChanges.subscribe(() => {
      this.refreshDiagnosiIcd10Validators();
      this.refreshIcd9SuggestionsFromIcd10(true);
    });
    this.contattoForm.get('diagnosiChiusuraIcd10')?.valueChanges.subscribe(() => {
      this.refreshDiagnosiIcd10Validators();
      this.refreshIcd9SuggestionsFromIcd10(false);
    });

    if (!this.contattoIsNew(this.contatto)) {
      this.refreshChiusuraControls()
    }



    if (this.isFormTerritoriale()) {
      this.contattoForm.controls['aperturaFlag'].addValidators([Validators.required])
    } else {
      this.removeRichiestaPrevFormField()
      this.addSemiresidenzialeFormFields()
    }

    this.observeFormChanges()

  }

  setDateModels(contatto: Contatto) {
    let richiestaData = new Date(contatto.dataRichiesta!!)
    this.richiestaDataModel = this.sessionSevice.convertToDateStruct(richiestaData)!!

    if (contatto.dataApertura != null) {
      let apeData = new Date(contatto.dataApertura!!)
      this.aperturaDataModel = this.sessionSevice.convertToDateStruct(apeData)!!
    }

    if (contatto.dataChiusura == null) {

      this.chiusuraDataModel = null;

    } else {
      let chiusuraDate = new Date(contatto.dataChiusura)
      this.chiusuraDataModel = this.sessionSevice.convertToDateStruct(chiusuraDate)!!

    }

  }


  observeFormChanges() {

    this.contattoForm.valueChanges.forEach(val => {

      let obj = val

      if (!this.isFormTerritoriale()) {


        //per pi altro
        if (this.proggetoInterventiBlockIsFalse(obj.interventoRiabilitativi, obj.interventoInserimentiLavorativi,
          obj.interventoInterveniSociali, obj.interventoColloquiPsichiatrici, obj.interventoCoinvolgimento)) {

          this.contattoForm.controls['altro']?.addValidators([Validators.required])
          this.contattoForm.controls['altro']?.updateValueAndValidity({ onlySelf: true, emitEvent: false })

        } else {
          this.contattoForm.controls['altro']?.removeValidators([Validators.required])
          this.contattoForm.controls['altro']?.updateValueAndValidity({ onlySelf: true, emitEvent: false })
          // this.contattoForm.updateValueAndValidity({onlySelf:true})
        }


        // makes ie section obligattory
        this.setIeSectionValidators(obj.dataChiusura)

        // per ie altro obligatory
        if (this.interveniEffetuatiBlockIsFalse(obj.interventoEffettuatoRiabilitativi, obj.interventoEffettuatoLavorativi,
          obj.interventoEffettuatoInterveniSociali, obj.interventoEffettuatoColloquiPsichiatrici,
          obj.interventoEffettuatoCoinvolgimento)) {

          this.contattoForm.controls['interventoEffettuatoAltro']?.setValidators([Validators.required])
          this.contattoForm.get('interventoEffettuatoAltro')?.updateValueAndValidity({ onlySelf: true })

        } else {
          this.contattoForm.get('interventoEffettuatoAltro')?.removeValidators([Validators.required])
          this.contattoForm.get('interventoEffettuatoAltro')?.updateValueAndValidity({ onlySelf: true })

        }
        ;

        this.setValidatorsBasedOnFlag(obj.aperturaFlag)

      } else {
        this.setValidatorsBasedOnFlag(obj.aperturaFlag)
      }


    })


    this.contattoForm.get('dataRichiesta')?.valueChanges.subscribe(date => {

      this.limitAperturaDateByRichiestaDate(date)
    })

    this.contattoForm.get('dataApertura')?.valueChanges.subscribe(date => {
      if (date) {
        this.limitChiusuraDateByAperturaDate(date)
      }

    })

  }


  limitAperturaDateByRichiestaDate(dataRichiesta: NgbDateStruct) {

    switch (dataRichiesta) {

      case undefined:

        break;
      default:
        // apertura by data richiesta
        this.minAperturaDateModel = { year: dataRichiesta!!.year, month: dataRichiesta!!.month, day: dataRichiesta!!.day }
        break;
    }


  }


  limitChiusuraDateByAperturaDate(dataApertura: NgbDateStruct) {

    switch (dataApertura) {
      case undefined:
        break;
      default:
        // chiusura date by apertura date
        this.minChiusuraDateModel = { year: dataApertura!!.year, month: dataApertura!!.month, day: dataApertura!!.day }

        break;

    }


  }

  proggetoInterventiBlockIsFalse(p1: string, p2: string, p3: string, p4: string, p5: string,) {

    if (p1 == "false" && p2 == "false" && p3 == "false" && p4 == "false" && p5 == "false") {

      return true

    } else {
      return false
    }

  }

  interveniEffetuatiBlockIsFalse(p1: string, p2: string, p3: string, p4: string, p5: string,) {

    if (p1 == "false" && p2 == "false" && p3 == "false" && p4 == "false" && p5 == "false") {

      return true

    } else {
      return false
    }

  }


  async refreshChiusuraControls() {
    // ICD9
    if (this.contatto.codiceDiagnosiChiusura != null && this.contatto.descrizioneDiagnosiChiusura != null) {
      this.modelChiusuraDiagnosi = new Diagnosi()
      this.modelChiusuraDiagnosi.codice = this.contatto.codiceDiagnosiChiusura;
      this.modelChiusuraDiagnosi.descrizione = this.contatto.descrizioneDiagnosiChiusura
    } else {
      this.modelChiusuraDiagnosi = null;
    }

    // ICD10 (indipendente dalla presenza/descrizione ICD9: per operatore-regione può risultare vuota altrimenti)
    this.modelChiusuraDiagnosiIcd10 = null
    if (this.contatto.codiceDiagnosiChiusuraIcd10
      && this.contatto.codiceDiagnosiChiusuraIcd10.toString().trim() !== '') {
      const diag = new DiagnosiIcd10()
      diag.codice = this.contatto.codiceDiagnosiChiusuraIcd10
      diag.descrizione = await this.getDiagnosiIcd10NameByCodice(diag.codice)
      this.modelChiusuraDiagnosiIcd10 = diag
    }

    this.contattoForm.get("dataChiusura")?.setValidators([Validators.required])
    this.contattoForm.get("dataChiusura")?.updateValueAndValidity()
    this.contattoForm.get('diagnosiChiusuraIcd10')?.setValue(this.modelChiusuraDiagnosiIcd10, { emitEvent: false });
    this.refreshDiagnosiIcd10Validators();
    this.refreshIcd9SuggestionsFromIcd10(false);
  }

  removeChiusuraFormFields() {

    this.contattoForm.removeControl("dataChiusura")
    this.contattoForm.removeControl('diagnosiChiusura')
    this.contattoForm.removeControl("modalitaConclusione")

  }

  removeRichiestaPrevFormField() {

    this.contattoForm.removeControl("richiestaPrev")
  }

  addSemiresidenzialeFormFields() {

    this.contattoForm.addControl("interventoRiabilitativi", new FormControl(this.setValue(this.contatto.interventoRiabilitativi), [Validators.required]))
    this.contattoForm.addControl("interventoInserimentiLavorativi", new FormControl(this.setValue(this.contatto.interventoInserimentiLavorativi), [Validators.required]))
    this.contattoForm.addControl("interventoInterveniSociali", new FormControl(this.setValue(this.contatto.interventoInterveniSociali), [Validators.required]))
    this.contattoForm.addControl("interventoColloquiPsichiatrici", new FormControl(this.setValue(this.contatto.interventoColloquiPsichiatrici), [Validators.required]))
    this.contattoForm.addControl("interventoCoinvolgimento", new FormControl(this.setValue(this.contatto.interventoCoinvolgimento), [Validators.required]))
    this.contattoForm.addControl("altro", new FormControl(this.contatto.altro))

    this.contattoForm.addControl("interventoEffettuatoRiabilitativi", new FormControl(this.setValue(this.contatto.interventoEffettuatoRiabilitativi)))
    this.contattoForm.addControl("interventoEffettuatoLavorativi", new FormControl(this.setValue(this.contatto.interventoEffettuatoLavorativi)))
    this.contattoForm.addControl("interventoEffettuatoInterveniSociali", new FormControl(this.setValue(this.contatto.interventoEffettuatoInterveniSociali)))
    this.contattoForm.addControl("interventoEffettuatoColloquiPsichiatrici", new FormControl(this.setValue(this.contatto.interventoEffettuatoColloquiPsichiatrici)))
    this.contattoForm.addControl("interventoEffettuatoCoinvolgimento", new FormControl(this.setValue(this.contatto.interventoEffettuatoCoinvolgimento)))
    this.contattoForm.addControl("interventoEffettuatoAltro", new FormControl(this.contatto.interventoEffettuatoAltro))

  }


  setIeSectionValidators(date: NgbDateStruct) {


    if (date != null || date != undefined) {

      this.contattoForm.controls["interventoEffettuatoRiabilitativi"].addValidators([Validators.required])
      this.contattoForm.controls["interventoEffettuatoRiabilitativi"].updateValueAndValidity({ onlySelf: true })

      this.contattoForm.controls["interventoEffettuatoLavorativi"].addValidators([Validators.required])
      this.contattoForm.controls["interventoEffettuatoLavorativi"].updateValueAndValidity({ onlySelf: true })

      this.contattoForm.controls["interventoEffettuatoInterveniSociali"].addValidators([Validators.required])
      this.contattoForm.controls["interventoEffettuatoInterveniSociali"].updateValueAndValidity({ onlySelf: true })

      this.contattoForm.controls["interventoEffettuatoColloquiPsichiatrici"].addValidators([Validators.required])
      this.contattoForm.controls["interventoEffettuatoColloquiPsichiatrici"].updateValueAndValidity({ onlySelf: true })

      this.contattoForm.controls["interventoEffettuatoCoinvolgimento"].addValidators([Validators.required])
      this.contattoForm.controls["interventoEffettuatoCoinvolgimento"].updateValueAndValidity({ onlySelf: true })


    } else {

      this.contattoForm.controls["interventoEffettuatoRiabilitativi"].removeValidators([Validators.required])
      this.contattoForm.controls["interventoEffettuatoRiabilitativi"].updateValueAndValidity({ onlySelf: true })

      this.contattoForm.controls["interventoEffettuatoLavorativi"].removeValidators([Validators.required])
      this.contattoForm.controls["interventoEffettuatoLavorativi"].updateValueAndValidity({ onlySelf: true })

      this.contattoForm.controls["interventoEffettuatoInterveniSociali"].removeValidators([Validators.required])
      this.contattoForm.controls["interventoEffettuatoInterveniSociali"].updateValueAndValidity({ onlySelf: true })

      this.contattoForm.controls["interventoEffettuatoColloquiPsichiatrici"].removeValidators([Validators.required])
      this.contattoForm.controls["interventoEffettuatoColloquiPsichiatrici"].updateValueAndValidity({ onlySelf: true })

      this.contattoForm.controls["interventoEffettuatoCoinvolgimento"].removeValidators([Validators.required])
      this.contattoForm.controls["interventoEffettuatoCoinvolgimento"].updateValueAndValidity({ onlySelf: true })


    }
  }

  setValue(value: any) {

    if (value === false) {
      return "false"
    } else if (value === true) {
      return "true"
    } else if (value === null || value === undefined) {
      return ""
    } else {
      return undefined
    }

  }

  isFormTerritoriale(): boolean {
    return this.isTipoPrestazioneTerritoriale();
    //    return this.sessionSevice.isSelectedStrutturaFromStorageTerritoriale()
  }

  tabInterventiVisible() {
    return this.isTipoPrestazioneTerritoriale();
    //    return this.sessionSevice.isSelectedStrutturaFromStorageTerritoriale();
  }

  tabDiagnosiVisible() {
    return this.isTipoPrestazioneTerritoriale();
    //    return this.sessionSevice.isSelectedStrutturaFromStorageTerritoriale();
  }

  tabPrestazioniAccessible() {
    // this.dettaglioAnagrafica.id != null;
    return this.contatto.id != null
  }


	  getInsertedValues() {
    let contatto = new Contatto()

    if (this.contatto.id != null) {
      contatto.id = this.contatto.id;
    }
    contatto.dataRichiesta = this.showDataRichiestaInput()
      ? this.sessionSevice.toNativeDate(this.richiestaDataModel)!!
      : undefined;
    contatto.tipoPrestazione = this.sessionSevice.isSelectedStrutturaFromStorageTerritoriale() ? "Territoriale" : "Semiresidenziale";
    //this.contattoForm.controls['tipoPrestazione'].value

    if (this.contattoForm.contains("richiestaPrev")) {
      contatto.richiestaPrev = this.contattoForm.controls['richiestaPrev'].value
    }

    if (this.aperturaFlag != null) {

      contatto.aperturaFlag = this.aperturaFlag!
    }


    contatto.dataApertura = this.sessionSevice.toNativeDate(this.aperturaDataModel)!!

    if (this.modelAperturaDiagnosi != null) {
      contatto.codiceDiagnosiApertura = this.modelAperturaDiagnosi.codice
      contatto.descrizioneDiagnosiApertura = this.modelAperturaDiagnosi.descrizione
    }
    if (this.chiusuraTerritoriale && this.confermadiagnosichiusuraterritoriale === "true") {
      contatto.codiceDiagnosiChiusura = this.lastDiagnosiEScale.diagnosi;
      contatto.descrizioneDiagnosiChiusura = this.lastDiagnosiEScale.descrizioneDiagnosi;
    }
    contatto.precedentiContatti = this.contattoForm.controls['precedentiContatti'].value
    contatto.inviante = this.contattoForm.controls['inviante'].value

    if (this.isContattoSemiResideziale(this.contatto.tipoPrestazione!!)) {

      contatto.interventoRiabilitativi = this.contattoForm.controls['interventoRiabilitativi'].value
      contatto.interventoInserimentiLavorativi = this.contattoForm.controls['interventoInserimentiLavorativi'].value
      contatto.interventoInterveniSociali = this.contattoForm.controls['interventoInterveniSociali'].value
      contatto.interventoColloquiPsichiatrici = this.contattoForm.controls['interventoColloquiPsichiatrici'].value
      contatto.interventoCoinvolgimento = this.contattoForm.controls['interventoCoinvolgimento'].value
      contatto.altro = this.contattoForm.controls['altro'].value

    }
    if (!this.isContattoSemiResideziale(this.contatto.tipoPrestazione!) && this.contattoIsNew(this.contatto) && this.aperturaFlag === "1") {
      contatto.codiceDiagnosiApertura = this.modelAperturaDiagnosi.codice
      contatto.descrizioneDiagnosiApertura = this.modelAperturaDiagnosi.descrizione
    }
    if (!this.contattoIsNew(this.contatto)) {


      contatto.dataChiusura = this.sessionSevice.toNativeDate(this.chiusuraDataModel)!!
      if (this.modelChiusuraDiagnosi != undefined) {
        contatto.codiceDiagnosiChiusura = this.modelChiusuraDiagnosi.codice
        contatto.descrizioneDiagnosiChiusura = this.modelChiusuraDiagnosi.descrizione

      }


      contatto.modalitaConclusione = this.contattoForm.controls['modalitaConclusione'].value
    }
    /**
     * [ADEGUAMENTO-ICD10][#24]
     *
     * @lastUpdate 2026-02-03 - Alessio Scoppetta
     *
     */
    const diagnosiAperturaIcd10 = this.resolveDiagnosiIcd10Model(this.contattoForm.get('diagnosiAperturaIcd10')?.value ?? this.modelAperturaDiagnosiIcd10);
    if (diagnosiAperturaIcd10) {
      contatto.codiceDiagnosiAperturaIcd10 = diagnosiAperturaIcd10.codice;
      this.modelAperturaDiagnosiIcd10 = diagnosiAperturaIcd10;
      this.contattoForm.get('diagnosiAperturaIcd10')?.setValue(diagnosiAperturaIcd10, { emitEvent: false });
    }

    const diagnosiChiusuraIcd10 = this.resolveDiagnosiIcd10Model(this.contattoForm.get('diagnosiChiusuraIcd10')?.value ?? this.modelChiusuraDiagnosiIcd10);
    if (diagnosiChiusuraIcd10) {
      contatto.codiceDiagnosiChiusuraIcd10 = diagnosiChiusuraIcd10.codice;
      this.modelChiusuraDiagnosiIcd10 = diagnosiChiusuraIcd10;
      this.contattoForm.get('diagnosiChiusuraIcd10')?.setValue(diagnosiChiusuraIcd10, { emitEvent: false });
    }



    if (this.isContattoSemiResideziale(this.contatto.tipoPrestazione!!)) {
      if (this.dataChiusuraExist()) {
        contatto.interventoEffettuatoRiabilitativi = this.contattoForm.controls['interventoEffettuatoRiabilitativi'].value
        contatto.interventoEffettuatoLavorativi = this.contattoForm.controls['interventoEffettuatoLavorativi'].value
        contatto.interventoEffettuatoInterveniSociali = this.contattoForm.controls['interventoEffettuatoInterveniSociali'].value
        contatto.interventoEffettuatoColloquiPsichiatrici = this.contattoForm.controls['interventoEffettuatoColloquiPsichiatrici'].value
        contatto.interventoEffettuatoCoinvolgimento = this.contattoForm.controls['interventoEffettuatoCoinvolgimento'].value
        contatto.interventoEffettuatoAltro = this.contattoForm.controls['interventoEffettuatoAltro'].value
      } else {
        contatto.interventoEffettuatoRiabilitativi = null
        contatto.interventoEffettuatoLavorativi = null
        contatto.interventoEffettuatoInterveniSociali = null
        contatto.interventoEffettuatoColloquiPsichiatrici = null
        contatto.interventoEffettuatoCoinvolgimento = null
        contatto.interventoEffettuatoAltro = null
      }
    }

    contatto.anagrafica = this.anagrafica

    return contatto

  }


  contattoIsNew(contatto: Contatto) {

    return contatto.id == null || contatto.id == undefined
  }

  /**
   * Ottiene la max data tra interventi, presenze, prestazioni e diagnosi per il confronto con la data chiusura del contatto
   * @returns
   */
  checkDateForCloseContact(): Date {

    let listInter = this.contatto.interventiList;
    let listPresenze = this.contatto.presenzaList;
    let listPrestazioni = this.contatto.prestazioniList;
    let listDiagnosi = this.contatto.diagnosiEScaleList;
    let dateList = new Array();

    if (listInter != null && listInter.length > 0) {

      let maxIntervallData = listInter.reduce((a, b) => {

        return a.data! > b.data! ? a : b;

      });

      dateList.push(maxIntervallData.data);

    }

    if (listPresenze != null && listPresenze.length > 0) {

      let maxPresenzeData = listPresenze.reduce((a, b) => {

        return a.dataPresenza! > b.dataPresenza! ? a : b;

      });

      dateList.push(maxPresenzeData.dataPresenza);

    }

    if (listPrestazioni != null && listPrestazioni.length > 0) {

      let maxPrestazioniData = listPrestazioni.reduce((a, b) => {

        return a.dataPrestazione! > b.dataPrestazione! ? a : b;
      });

      dateList.push(maxPrestazioniData.dataPrestazione);

    }

    if (listDiagnosi != null && listDiagnosi.length > 0) {

      let maxDiagnosiData = listDiagnosi.reduce((a, b) => {

        return a.data! > b.data! ? a : b;

      });

      dateList.push(maxDiagnosiData.data);

    }

    let maxData = dateList.reduce((a, b) => {

      return a > b ? a : b;

    });

    return maxData;

  }

  checkDateForOpenContact(): Date | null {

    let listPresenze = this.contatto.presenzaList;
    let listPrestazioni = this.contatto.prestazioniList;
    let dateList = new Array();

    if (listPresenze != null && listPresenze.length > 0) {
      let minPresenzeData = listPresenze.reduce((a, b) => {
        return a.dataPresenza! < b.dataPresenza! ? a : b;
      });

      dateList.push(minPresenzeData.dataPresenza);
    }

    if (listPrestazioni != null && listPrestazioni.length > 0) {
      let minPrestazioniData = listPrestazioni.reduce((a, b) => {
        return a.dataPrestazione! < b.dataPrestazione! ? a : b;
      });

      dateList.push(minPrestazioniData.dataPrestazione);
    }

    if (dateList.length > 0) {
      let minData = dateList.reduce((a, b) => {
        return a < b ? a : b;
      });
      return minData;
    } else {
      return null;
    }
  }


  async submitForm(redirect2interventoForm?: boolean) {
    // this.printErrors();

    //if(!this.contatto.id) {
    //   await this.anagraficaPanel?.saveAnagrafica(true);
    // }

    //lo forzo
    this.anagraficaOK = true;
    if ((!this.contatto.id && this.anagraficaOK) || this.contatto.id) {

      this.contattoFormSubmitted = true

      let piAltroError = false
      let ieAltroError = false
      let diagnosiChiusuraError = false;
      let modalitaConclusioneError = false;
      let interventoEffettuatoRiabilitativiError = false;
      let interventoEffettuatoLavorativiError = false;
      let interventoEffettuatoInterveniSocialiError = false;
      let interventoEffettuatoColloquiPsichiatriciError = false;
      let interventoEffettuatoCoinvolgimentoError = false;

      if (this.contattoForm.contains('altro')) {
        piAltroError = this.contattoForm.controls['altro'].getError("required")
      }
      if (this.contattoForm.contains('diagnosiChiusura')) {
        diagnosiChiusuraError = this.contattoForm.controls['diagnosiChiusura'].getError("required")
      }
      if (this.contattoForm.contains('modalitaConclusione')) {
        modalitaConclusioneError = this.contattoForm.controls['modalitaConclusione'].getError("required")
      }
      if (this.contattoForm.contains('interventoEffettuatoRiabilitativi')) {
        interventoEffettuatoRiabilitativiError = this.contattoForm.controls['interventoEffettuatoRiabilitativi'].getError("required")
      }
      if (this.contattoForm.contains('interventoEffettuatoLavorativi')) {
        interventoEffettuatoLavorativiError = this.contattoForm.controls['interventoEffettuatoLavorativi'].getError("required")
      }
      if (this.contattoForm.contains('interventoEffettuatoInterveniSociali')) {
        interventoEffettuatoInterveniSocialiError = this.contattoForm.controls['interventoEffettuatoInterveniSociali'].getError("required")
      }
      if (this.contattoForm.contains('interventoEffettuatoColloquiPsichiatrici')) {
        interventoEffettuatoColloquiPsichiatriciError = this.contattoForm.controls['interventoEffettuatoColloquiPsichiatrici'].getError("required")
      }
      if (this.contattoForm.contains('interventoEffettuatoCoinvolgimento')) {
        interventoEffettuatoCoinvolgimentoError = this.contattoForm.controls['interventoEffettuatoCoinvolgimento'].getError("required")
      }
      if (this.contattoForm.contains('interventoEffettuatoAltro')) {
        ieAltroError = this.contattoForm.controls['interventoEffettuatoAltro'].getError("required")
      }


      // let valid = this.contattoForm.valid
      let update: boolean = false;
      if (this.contatto.id) {
        update = true;
      }
      if (!this.dataChiusuraExist()) {
        if (this.contattoForm.get('dataChiusura')) {

          this.contattoForm.get('dataChiusura')?.removeValidators([Validators.required])
          this.contattoForm.controls['dataChiusura'].updateValueAndValidity({ onlySelf: true, emitEvent: false })
        }
      }

      if (new CommonsUtil().validFields(this.contattoForm)
        && !piAltroError
        && !ieAltroError && (!diagnosiChiusuraError) && (!modalitaConclusioneError) && !interventoEffettuatoRiabilitativiError && !interventoEffettuatoLavorativiError && !interventoEffettuatoInterveniSocialiError && !interventoEffettuatoColloquiPsichiatriciError
        && !interventoEffettuatoCoinvolgimentoError) {
        if (this.chiusuraDataModel == null || this.contattoCanBeClosed()) {

          let contatto = this.getInsertedValues()
          contatto.codiceAslOperatoreInserimento = this.utente.codiceAsl;
          let codiceStruttura = this.sessionSevice.getSelectedStrutturaFromStorage()?.codice


        /**
         * [ADEGUAMENTO-ICD10][#25]
         *
         * Validazione per contatto con diagnosi apertura NO
         * @lastUpdate 2026-02-12 - AMS
         */
          if (this.isTipoPrestazioneTerritoriale() && this.contattoIsNew(this.contatto) && this.hasUltimoContattoSenzaAperturaDichiarata(contatto)) {
            this.toastService.showError("Attenzione non è possibile creare un nuovo contatto: l ultimo contatto risulta senza apertura contatto dichiarata.");
            return;
          }

          /**
           * [ADEGUAMENTO-ICD10][#25]
           *
           * Validazione per contatto con diagnosi apertura NO
           * @lastUpdate 2026-03-12 - AMS
          */
          if (this.isTipoPrestazioneTerritoriale() && this.hasGiaContattoConAperturaNo(contatto)) {
            this.toastService.showError("Attenzione! Non e' possibile salvare il contatto: e' gia' presente un contatto non avviato con data richiesta uguale");
            return;
          }

          const shouldValidateOpenContactRules = this.shouldValidateOpenContactRules(update, contatto);
          if (shouldValidateOpenContactRules) {
            if (this.esisteUnaltroContatto(contatto)) {

              this.toastService.showError("Attenzione non è possibile inserire il contatto con questa data perchè esiste già un contatto aperto");
              return;

            }
            if (!this.isOutOfRangeOtherContact(contatto)) {

              this.toastService.showError('La data apertura non può essere compresa tra la data apertura e la data chiusura di un contatto esistente');
              return;

            }

            let minDate = this.checkDateForOpenContact();

            if (minDate != null) {

              minDate = new Date(minDate);

              if (contatto.dataApertura!.getTime() > minDate.getTime()) {

                this.toastService.showError('La data apertura non può essere maggiore delle presenze e/o prestazioni');
                return;

              }

            }
          }

          if (this.dataChiusuraExist()) {
            let maxDate = this.checkDateForCloseContact();

            maxDate = new Date(maxDate);

            if (maxDate.getTime() > contatto.dataChiusura!.getTime()) {

              if (this.isContattoSemiResideziale(this.contatto!.tipoPrestazione!)) {
                this.toastService.showError('La data di chiusura non può essere precedente alle date delle presenze e/o prestazioni');

              } else {
                this.toastService.showError('La data di chiusura non può essere precedente alle date degli interventi, diagnosi e/o prestazioni');

              }

              return;

            }

          }

          let canClose: boolean = true;
          if (contatto.tipoPrestazione == 'Semiresidenziale') {

            if ((contatto.dataChiusura || contatto.codiceDiagnosiChiusura || contatto.modalitaConclusione)) {
              if (!contatto.dataChiusura || !contatto.codiceDiagnosiChiusura || !contatto.modalitaConclusione) {
                canClose = false;
              }
            }

          }
          /**
           *
           * [ADEGUAMENTO-ICD10][#40] in caso di data chiusura null/undefined,
           * toValidDate ritorna null e non viene propagata la modifica a
           * Diagnosi/Interventi (comportamento desiderato in caso di
           * riapertura contatto)
           *
           * @history Modifiche MC 2025/05/13 - Aggiornamento diagnosi e interventi
           * @lastUpdate 2026-02-26 - AMS
          */

          if (update) {
            const vecchiaDataApertura = new Date(this.contatto.dataApertura!);
            const nuovaDataApertura = new Date(contatto.dataApertura!);
            const vecchiaAperturaStr = vecchiaDataApertura.toISOString().split('T')[0];
            const nuovaAperturaStr = nuovaDataApertura.toISOString().split('T')[0];
            const vecchiaDataChiusura = this.toValidDate(this.contatto.dataChiusura);
            const nuovaDataChiusura = this.toValidDate(contatto.dataChiusura);
            const vecchiaChiusuraStr = vecchiaDataChiusura ? vecchiaDataChiusura.toISOString().split('T')[0] : null;
            const nuovaChiusuraStr = nuovaDataChiusura ? nuovaDataChiusura.toISOString().split('T')[0] : null;

            try {
              if (this.contatto.diagnosiEScaleList && this.contatto.interventiList) {
                // Aggiorna se è cambiata la data di apertura
                if (vecchiaAperturaStr !== nuovaAperturaStr) {

                  await this.updateEntitaData(
                    this.contatto.diagnosiEScaleList,
                    "Diagnosi",
                    vecchiaAperturaStr,
                    nuovaDataApertura,
                    this.contatto.id!
                  );
                  await this.updateEntitaData(
                    this.contatto.interventiList,
                    "Intervento",
                    vecchiaAperturaStr,
                    nuovaDataApertura,
                    this.contatto.id!
                  );
                }

                // Aggiorna se è cambiata la data di chiusura
                // In caso di riapertura (pulizia data/diagnosi chiusura) non propagare modifiche a Diagnosi/Interventi.
                if (vecchiaChiusuraStr && nuovaChiusuraStr && vecchiaChiusuraStr !== nuovaChiusuraStr) {
                  await this.updateEntitaData(
                    this.contatto.diagnosiEScaleList,
                    "Diagnosi",
                    vecchiaChiusuraStr,
                    nuovaDataChiusura!,
                    this.contatto.id!
                  );
                  await this.updateEntitaData(
                    this.contatto.interventiList,
                    "Intervento",
                    vecchiaChiusuraStr,
                    nuovaDataChiusura!,
                    this.contatto.id!
                  );
                }
              }
            } catch (error) {
              console.error("Errore generale durante l'aggiornamento delle entità:", error);
            }
          }

          this.blockUI.start("Salvataggio in corso")

          if (canClose) {
            //if (contatto.aperturaFlag == '2' || (((contatto.dataChiusura != null && contatto.dataChiusura != undefined && this.contatto.dataChiusura != contatto.dataChiusura) || (contatto.dataApertura != null && contatto.dataApertura != undefined && this.contatto.dataApertura != contatto.dataApertura)) && !this.dateIsInRangeContattoSetting(contatto)) || update) {
            const confermaDiagnosi: boolean =
              this.chiusuraTerritoriale && this.confermadiagnosichiusuraterritoriale === 'true';

            this.apiService.saveContatto(contatto, codiceStruttura!!, redirect2interventoForm, confermaDiagnosi).subscribe({
              next: (res) => {

                if (res.id != null) {

                  this.contatto = res;
                  this.toastService.showSuccess('Salvataggio effettuato con successo');
                  this.sessionSevice.setSelectedContatto(this.contatto);

                }
                redirect2interventoForm ? this.router.navigate(['intervento-form']) : null;

              },

              error: (e) => {

                console.error(e);

                this.blockUI.stop();
                this.chiusuraTerritoriale = false;
                this.confermadiagnosichiusuraterritoriale = "";

                this.toastService.showError('Correggere gli errori di compilazione');
              },

              complete: () => {

                if (this.isTipoPrestazioneTerritoriale() && this.contatto.interventiList && this.contatto.interventiList?.length > 0) {

                  const interventi: Intervento[] = this.contatto.interventiList;
                  const interventiS: Intervento[] = interventi.sort((a, b) => a.id && b.id && a.id >= b.id ? -1 : 1);
                  this.blockUI.stop();

                  if (interventiS[0].rispostaPrevalente == '1' || interventiS[0].rispostaPrevalente == '2' || interventiS[0].rispostaPrevalente == '3') {
                    let intv = interventiS[0];

                    if (this.chiusuraTerritoriale) {
                      intv.ieTrattamentoPsicoterapeutico = this.contattoForm.get('ieTrattamentoPsicoterapeutico')?.value;
                      intv.ieTrattamentoFarmacologico = this.contattoForm.get('ieTrattamentoFarmacologico')?.value;
                      intv.ieInterventiRiabilitativi = this.contattoForm.get('ieInterventiRiabilitativi')?.value;
                      intv.ieInserimentiLavorativi = this.contattoForm.get('ieInserimentiLavorativi')?.value;
                      intv.ieInterventoSociale = this.contattoForm.get('ieInterventoSociale')?.value;
                      intv.ieColloquiSostegno = this.contattoForm.get('ieColloquiSostegno')?.value;
                      intv.ieCoinvolgimentoFamiliari = this.contattoForm.get('ieCoinvolgimentoFamiliari')?.value;
                      intv.ieAccertamentiMedicoLegali = this.contattoForm.get('ieAccertamentiMedicoLegali')?.value;
                      intv.ieInvioInStruttura = this.contattoForm.get('ieInvioInStruttura')?.value;
                      intv.ieInvioStpit = this.contattoForm.get('ieInvioStpit')?.value;
                      intv.ieLuogoStpit = this.contattoForm.get('ieLuogoStpit')?.value;
                      intv.ieInvioSrtri = this.contattoForm.get('ieInvioSrtri')?.value;
                      intv.ieLuogoSrtri = this.contattoForm.get('ieLuogoSrtri')?.value;
                      intv.ieInvioSrtre = this.contattoForm.get('ieInvioSrtre')?.value;
                      intv.ieLuogoSrtre = this.contattoForm.get('ieLuogoSrtre')?.value;
                      intv.ieInvioSrsr24 = this.contattoForm.get('ieInvioSrsr24')?.value;
                      intv.ieLuogoSrsr24 = this.contattoForm.get('ieLuogoSrsr24')?.value;
                      intv.ieInvioSrsr12 = this.contattoForm.get('ieInvioSrsr12')?.value;
                      intv.ieLuogoSrsr12 = this.contattoForm.get('ieLuogoSrsr12')?.value;
                      intv.ieInvioGa = this.contattoForm.get('ieInvioGa')?.value;
                      intv.ieLuogoGa = this.contattoForm.get('ieLuogoGa')?.value;
                      intv.ieInvioCd = this.contattoForm.get('ieInvioCd')?.value;
                      intv.ieLuogoCd = this.contattoForm.get('ieLuogoCd')?.value;
                      intv.ieInvioOspedale = this.contattoForm.get('ieInvioOspedale')?.value;
                      intv.ieInvioOspedaleRep40 = this.contattoForm.get('ieInvioOspedaleRep40')?.value;
                      intv.ieLuogoOspedale = this.contattoForm.get('ieLuogoOspedale')?.value;
                      intv.ieConsultazioneValutazione = this.contattoForm.get('ieConsultazioneValutazione')?.value;
                      intv.ieAltro = this.contattoForm.get('ieAltro')?.value;
                      //-------------------------
                      this.apiService.aggiornaIeIntervento(intv, codiceStruttura!!).subscribe({
                        next: (res) => {

                          this.toastService.showSuccess('Salvataggio effettuato con successo');
                          this.back();
                        },
                        error: (err) => {
                          console.error(err);
                          this.blockUI.stop()
                          this.toastService.showError('Correggere gli errori di compilazione');
                        },
                        complete: () => {
                          this.blockUI.stop()
                          this.back()
                          this.toastService.showSuccess('Salvataggio effettuato con successo');
                        }
                      })
                    } else {
                      this.blockUI.stop()
                      this.back();
                    }
                  } else {
                    this.blockUI.stop()
                    this.back();
                  }
                } else {
                  this.blockUI.stop()
                  this.back();
                }
                this.chiusuraTerritoriale = false;
                this.confermadiagnosichiusuraterritoriale = "";
                this.blockUI.stop();
              }
            });


          } else {
            this.blockUI.stop()
            this.toastService.showError("Attenzione non è possibile chiudere il contatto: data chiusura, modalità conclusione e codice diagnosi sono obbligatorie.");

          }
        } else {
          this.blockUI.start("Salvataggio in corso")
          this.blockUI.stop()
          this.toastService.showError(this.getMissingDataMessage())
        }
      } else {

        this.blockUI.stop()
        this.toastService.showError('Correggere errori di compilazione');
      }
    } else {
      this.tabShowed = TabShowedState.ANAGRAFICA;
    }
  }


  /**
   * Aggiorna la data di un'entità associata al contatto quando questa corrisponde
   * alla vecchia data di apertura del contatto
   * @param entityList Lista delle entità da controllare
   * @param entityType Tipo di entità ("Diagnosi" o "Intervento")
   * @param vecchiaData Data vecchia da cercare (formato ISO String YYYY-MM-DD)
   * @param nuovaData Data nuova da impostare (oggetto Date)
   * @param idContatto ID del contatto
   * @param apiService Servizio API da utilizzare
   * @param toastService Servizio Toast per i messaggi
   * @returns Promise<boolean> True se è stata trovata e aggiornata un'entità
   */
  async updateEntitaData(
    entityList: any[],
    entityType: string,
    vecchiaData: string,
    nuovaData: Date,
    idContatto: number,
  ): Promise<boolean> {
    try {
      let entityFound: any;

      if (!entityList || entityList.length === 0) {
        console.warn(`Nessuna ${entityType} presente per questo contatto`);
        return false;
      }

      entityList.forEach(element => {
        if (!element.data) {
          console.warn(`${entityType} con data mancante:`, element);
          return;
        }

        const dataEntity = new Date(element.data);
        if (isNaN(dataEntity.getTime())) {
          console.error(`Data ${entityType} non valida:`, element.data);
          return;
        }

        const dataEntityStr = dataEntity.toISOString().split('T')[0];

        // CERCA entità con data uguale alla VECCHIA data di apertura
        if (dataEntityStr === vecchiaData) {
          entityFound = element;
        }
      });

      if (entityFound) {
        entityFound.data = nuovaData.toISOString();

        // Assicuriamoci che l'oggetto contatto esista
        if (!entityFound.contatto) {
          entityFound.contatto = {};
        }

        // Assegniamo l'ID del contatto
        entityFound.contatto.id = idContatto;

        // Esegui il salvataggio in base al tipo di entità
        if (entityType === "Diagnosi") {
          await lastValueFrom(
            this.apiService.saveDiagnosiEScala(
              entityFound,
              entityFound.codiceStrutturaOperatoreInserimento!
            )
          );
        } else if (entityType === "Intervento") {
          await lastValueFrom(
            this.apiService.saveIntervento(
              entityFound,
              entityFound.codiceStrutturaOperatoreInserimento!
            )
          );
        }

        //this.toastService.showSuccess(`${entityType} aggiornata alla nuova data di apertura`);
        return true;
      } else {
        console.warn(`Nessuna ${entityType} trovata con data uguale alla vecchia data di apertura del contatto`);
        return false;
      }
    } catch (error) {
      console.error(`Errore durante aggiornamento ${entityType}:`, error);
      this.toastService.showError(`Errore durante l'aggiornamento della ${entityType}`);
      return false;
    }
  }

  /**
   *
   * @param aslContattoAperto
   * @param aslUtente
   */

  loadContatti() {

    this.apiService.getAllContattiByAnagraficaIdAndStruttura(this.anagrafica.id!, this.sessionSevice.getSelectedStrutturaFromStorage()?.codice!).subscribe(res => {

      if (res) {
        this.listContatti = res;
      }

    });

  }

  isOutOfRangeOtherContact(contatto: Contatto): boolean {
    let dataApertura = contatto.dataApertura
    if (dataApertura) {
      for (let cont of this.listContatti!) {
        if (contatto.id != cont.id) {
          if (dataApertura >= new Date(cont.dataApertura!) && dataApertura <= new Date(cont.dataChiusura!)) {
            return false;
          }
        }
      }
    } else {
      return true;
    }
    return true;
  }

  esisteUnaltroContatto(contatto: Contatto): boolean {
    if (contatto.aperturaFlag == '1') {
      for (let cont of this.listContatti!) {
        if (contatto.id != cont.id) {
          if (!cont.dataChiusura! && cont.aperturaFlag == '1') {
            return true;
          }
        }
      }
    }
    return false;
  }

  hasGiaContattoConAperturaNo(contatto: Contatto): boolean {
    if (this.normalizeFlag(contatto.aperturaFlag) !== '2') {
      return false;
    }

    const nuovaDataAperturaOrRichiesta = contatto.dataApertura ?? contatto.dataRichiesta;
    return this.getContattiStessoSetting(contatto)
      .some(c =>
        this.normalizeFlag(c.aperturaFlag) === '2' &&
        this.isSameDay(c.dataRichiesta, nuovaDataAperturaOrRichiesta)
      );
  }

  hasUltimoContattoSenzaAperturaDichiarata(contatto: Contatto): boolean {
    const contattiStessoSetting = this.getContattiStessoSetting(contatto);
    if (contattiStessoSetting.length === 0) {
      return false;
    }

    const ultimoContatto = [...contattiStessoSetting]
      .sort((a, b) => this.compareForLastContatto(a, b))[0];
    return this.normalizeFlag(ultimoContatto.aperturaFlag) === '';
  }

  private getContattiStessoSetting(contatto: Contatto): Contatto[] {
    const tipoPrestazione = (contatto.tipoPrestazione ?? '').toLowerCase();
    return (this.listContatti ?? [])
      .filter(c =>
        contatto.id != c.id &&
        (c.tipoPrestazione ?? '').toLowerCase() === tipoPrestazione
      );
  }

  private compareForLastContatto(a: Contatto, b: Contatto): number {
    const timeA = this.getSortTimestamp(a);
    const timeB = this.getSortTimestamp(b);
    if (timeB !== timeA) {
      return timeB - timeA;
    }
    return (b.id ?? 0) - (a.id ?? 0);
  }

  private getSortTimestamp(contatto: Contatto): number {
    const dataInserimento = new Date(contatto.dataInserimento ?? '').getTime();
    if (!isNaN(dataInserimento)) {
      return dataInserimento;
    }
    const dataAggiornamento = new Date(contatto.dataAggiornamento ?? '').getTime();
    if (!isNaN(dataAggiornamento)) {
      return dataAggiornamento;
    }
    const dataRichiesta = new Date(contatto.dataRichiesta ?? '').getTime();
    return isNaN(dataRichiesta) ? 0 : dataRichiesta;
  }

  private normalizeFlag(flag?: string | null): string {
    return (flag ?? '').trim();
  }

  private isSameDay(first?: Date, second?: Date): boolean {
    if (!first || !second) {
      return false;
    }
    const d1 = new Date(first);
    const d2 = new Date(second);
    return d1.getFullYear() === d2.getFullYear()
      && d1.getMonth() === d2.getMonth()
      && d1.getDate() === d2.getDate();
  }

  private shouldValidateOpenContactRules(update: boolean, contatto: Contatto): boolean {
    if (!update) {
      return true;
    }

    const oldFlag = this.normalizeFlag(this.contatto?.aperturaFlag);
    const newFlag = this.normalizeFlag(contatto.aperturaFlag);
    const flagChanged = oldFlag !== newFlag;

    const oldApertura = this.contatto?.dataApertura ? new Date(this.contatto.dataApertura as any) : undefined;
    const newApertura = contatto.dataApertura ? new Date(contatto.dataApertura as any) : undefined;
    const dateChanged = (oldApertura || newApertura) ? !this.isSameDay(oldApertura, newApertura) : false;

    return flagChanged || dateChanged;
  }

  openPrestazioneForm() {
    this.sessionSevice.setSelectedPrestazione("");
    this.router.navigate(['prestazione'])
  }


  loadPrestazioni(id: number, pageNr: number, pageSize: number, order: string | null, direction: string | null) {
    if (id != null) {
      this.apiService.getPaginaPrestazioni(id, pageNr, pageSize, order, direction).subscribe(res => {
        this.page = res
      })
    }
  }


  changeOrder() {
    this.loadPrestazioni(this.contatto.id!!, this.page.number, this.page.size, this.tableSorter.orderByName(), this.tableSorter.orderByDirection())
  }

  cambiaPagina() {
    this.loadPrestazioni(this.contatto.id!!, this.page.number, this.page.size, this.tableSorter.orderByName(), this.tableSorter.orderByDirection())
  }

  selectPrestazione(prestazione: Prestazione) {
    this.sessionSevice.setSelectedPrestazione(JSON.stringify(prestazione))
    this.router.navigate(['prestazione'])
  }


  openGoBackDialog(content: any) {
    if (!this.contattoForm.touched) {
      this.back()
    } else {
      this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
        if (this.closeResult === 'Closed with: Back click') {
          this.back()
        }
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  back() {
    //this.sessionSevice.setOpenTabAnagrafica("TabContatti")
    this.router.navigate(['contattiList'])
  }


  async getDiagnosi() {
    this.apiService.getAllDiagnosi().subscribe(res => {
      this.listDiagnosiApertura = res

      this.listDiagnosiChiusura = res

    })
  }

  /**
   * Recupera l'elenco delle diagnosi ICD-10
   *
   * [ADEGUAMENTO-ICD10][#24]
   * @lastUpdate 2026-02-03 - Alessio Scoppetta
   */
  async getDiagnosiIcd10() {
    this.apiService.getAllDiagnosiIcd10().subscribe(res => {
      this.listDiagnosiIcd10 = res
    })
  }

    /**
   * Mostra o nasconde i campi per la diagnosi ICD-10 in base alle regole definite
   * dalle fasi del progetto ( obbligatorietà post data, etc... )
   *
   * [ADEGUAMENTO-ICD10][#25]
   * @lastUpdate 2026-02-03 - Alessio Scoppetta
   *
   */
  showDiagnosiIcd10(): boolean {
    return true;
  }
  private isSameOrAfterDay(date: Date, threshold: Date): boolean {
    const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const t = new Date(threshold.getFullYear(), threshold.getMonth(), threshold.getDate());
    return d.getTime() >= t.getTime();
  }

  showDataRichiestaInput(): boolean {
    // Il campo Data richiesta deve restare sempre visibile in scheda contatto.
    return true;
  }

  private refreshDataRichiestaVisibility(): void {
    const control = this.contattoForm?.get('dataRichiesta');
    if (!control) {
      return;
    }

    if (this.showDataRichiestaInput()) {
      control.setValidators([Validators.required, dataNonValidaValidator()]);
    } else {
      this.richiestaDataModel = null as any;
      control.setValue(null, { emitEvent: false });
      control.clearValidators();
    }

    control.updateValueAndValidity({ onlySelf: true, emitEvent: false });
  }


  async getAllPrecedentiContatti() {
    this.apiService.getAllPrecedentiContatti().subscribe(res => {
      this.listPrecedentiContatti = res
    })
  }

  async getAllModalitaConclusione() {
    this.apiService.getAllModalitaConclusione().subscribe(res => {
      this.listaModalitaConclusione = res
    })
  }


  async getRichiestePrevalenti() {
    this.apiService.getAllRichiestePrevalenti().subscribe(res => {
      this.listRichiestePrevalenti = res
    })
  }


  async getInviantiTerritoriali() {

    this.apiService.getAllInviantiTerritoriale().subscribe(res => {
      this.listInvianti = res
    })


  }

  async getInviantiSemiResidenziali() {

    this.apiService.getAllInviantiSemiresidenziali().subscribe(res => {
      this.listInvianti = res
    })
  }


  /**
   * metodi per la gestione dei permessi
   */
  salvaVisibile() {
    if (this.tabShowed == TabShowedState.ANAGRAFICA) {
      return false;
    }
    let utente = this.sessionSevice.getUtenteFromStorage();
    return utente?.funzionalita.includes(Funzionalita.ANAGRAFICHE_INSERIMENTO);
  }

  isValidato() {
    if (this.contatto.statoAttuale.id == 3) {
      return true
    } else {
      return false;
    }
  }

  navigateToAnagrafica() {
    this.router.navigate(['contattiList'])
  }


  loadTab() {
    this.sessionSevice.comingPathContatto.subscribe(res => {
      if (res === "TabPrestazoni") {
        this.tabShowedPrestazioni()
      } else if (res === "TabDiagnosiScale") {
        this.tabShowedDiagnosiScale()
      } else if (res === "TabInterventi") {
        this.tabShowedInterventi()
      } else if (res === "TabPresenze") {
        this.tabShowedPresenze()
      } else {
        this.tabShowedContatti()
      }
    })
  }

  tabShowedContatti() {
    this.deleteVisible = false
    this.tabShowed = TabShowedState.CONTATTI;
  }

  tabShowedAnagrafica() {
    this.deleteVisible = true
    this.tabShowed = TabShowedState.ANAGRAFICA;
  }

  tabShowedPrestazioni() {
    this.deleteVisible = true
    this.tabShowed = TabShowedState.PRESTAZIONI;
  }

  tabShowedInterventi() {
    this.deleteVisible = true
    this.tabShowed = TabShowedState.INTERVENTI;
  }

  tabShowedDiagnosiScale() {
    this.deleteVisible = true
    this.tabShowed = TabShowedState.DIAGNOSISCALE;
  }

  ngOnDestroy() {
    this.sessionSevice.setOpenTabContatto("");
    if (this.subscribe1) this.subscribe1.unsubscribe();
    if (this.subscribe2) this.subscribe2.unsubscribe();
    //console.log("Call undestroy")
  }


  tabShowedPresenze() {
    this.deleteVisible = true
    this.tabShowed = TabShowedState.PRESENZE;
  }

  tabContattiClasses() {
    return this.tabShowed == TabShowedState.CONTATTI ?
      'active' : '';
  }

  tabPaneContattiClasses() {
    return this.tabShowed == TabShowedState.CONTATTI ?
      'active show' : '';
  }

  tabPaneAnagraficaClasses() {
    return this.tabShowed == TabShowedState.ANAGRAFICA ?
      'active show' : '';
  }

  tabPrestazioniClasses() {
    return this.tabShowed == TabShowedState.PRESTAZIONI ?
      'active' : '';
  }

  tabInterventiClasses() {
    return this.tabShowed == TabShowedState.INTERVENTI ?
      'active' : '';
  }

  tabPresenzeClasses() {
    return this.tabShowed == TabShowedState.PRESENZE ?
      'active' : '';
  }

  tabDiagnosiEScaleClasses() {
    return this.tabShowed == TabShowedState.DIAGNOSISCALE ?
      'active' : '';
  }

  tabPanePrestazioniClasses() {
    return this.tabShowed == TabShowedState.PRESTAZIONI ?
      'active show' : '';
  }

  tabPaneInterventiClasses() {
    return this.tabShowed == TabShowedState.INTERVENTI ?
      'active show' : '';
  }

  tabPaneDiagnosiScaleClasses() {
    return this.tabShowed == TabShowedState.DIAGNOSISCALE ?
      'active show' : '';
  }

  tabPanePresenzeClasses() {
    return this.tabShowed == TabShowedState.PRESENZE ?
      'active show' : '';
  }

  formatText(text: string | null): string | null {
    if (text != null && text.length > 25) {
      return text.slice(0, 25) + "..."
    } else {
      return text ? text : ""
    }
  }


  isTipoPrestazioneTerritoriale(): boolean {
    if (this.contatto != null) {
      return this.contatto.tipoPrestazione == "Territoriale";
    } else {
      return false;
    }
  }

/**
* [ADEGUAMENTO-ICD10][#25] - Regola di scrittura: solo operatore-struttura può modificare i campi di apertura e chiusura del contatto, compresi i campi per la diagnosi ICD-10 (anche se "Da modificare").
 * @lastUpdate 2026-02-03 - Alessio Scoppetta
 *
 */
  hasWritePermission(utente: Utente): boolean {
    if (!utente) return false;
    if (!utente.funzionalita?.includes(Funzionalita.ANAGRAFICHE_INSERIMENTO)) return false;
    // Regola: su Contatti e Diagnosi&Scale può modificare solo operatore-struttura (anche se "Da modificare").
    return this.getRuolo(this.OPERATORE_STRUTTURA);
  }

  isRegioneOrAslOrDsm(): boolean {

    if (this.getRuolo(this.OPERATORE_REGIONE)  ||
      this.getRuolo(this.OPERATORE_ASL) ||
      this.getRuolo(this.OPERATORE_DSM)) {
      return true;
    }
    return false
  }


  setAperturaFlag(event: any) {
    this.aperturaFlag = event.target.value
    if (this.aperturaFlag == "1") {
      // this.toastService.showError("Attenzione, per questo setting esiste" +
      //   " già un contatto aperto il giorno " + this.contattoApertoSetting.dataApertura
      //   + ' dalla struttura con codice ' + this.contattoApertoSetting.codiceStrutturaOperatoreInserimento)
      this.contattoForm.get('aperturaFlag')?.patchValue('1')
      this.aperturaFlag = "1"
      this.setValidatorsBasedOnFlag(this.aperturaFlag)
      this.refreshDataRichiestaVisibility();
    } else {
      if (!this.contattoIsNew(this.contatto) && this.aperturaFlag == "2") {
        this.openChiudiContattoDialog('solofigli');
        this.setValidatorsBasedOnFlag(this.aperturaFlag)
      }
      if (this.aperturaFlag == "2") {
        this.aperturaDataModel = null;
        this.modelAperturaDiagnosi = null;
        this.contattoForm.get('precedentiContatti')?.patchValue('');
        this.contattoForm.get('inviante')?.patchValue('');
        this.modelChiusuraDiagnosi = null;
        this.chiusuraDataModel = null;
        this.contattoForm.get('modalitaConclusione')?.patchValue('');
      }
      this.refreshDataRichiestaVisibility();

    }
  }

  loadHasOpenContattiStatus(anagrafica: DettaglioAnagrafica) {
    this.apiService.getAllAnagraficaContatti(anagrafica.id!!).subscribe(res => {
      if (res) {
        this.allAnagraficaContatti = res;
      }
    })
  }

  setValidatorsBasedOnFlag(aperturaFlag: string | null) {
    if (aperturaFlag != null) {
      switch (aperturaFlag) {
        case "1":
          this.contattoForm.get('dataApertura')!!.addValidators([Validators.required, dataNonValidaValidator()])

          if (!this.hasWritePermission(this.mainUser) || !this.canEdit()) {
            this.contattoForm.get('dataApertura')!!.disable({ onlySelf: true })
            this.contattoForm.get('diagnosiApertura')!!.disable({ onlySelf: true })
            this.contattoForm.get('precedentiContatti')!!.disable({ onlySelf: true })
            this.contattoForm.get('inviante')!!.disable({ onlySelf: true })
          } else {
            this.contattoForm.get('dataApertura')!!.enable({ onlySelf: true })
            this.contattoForm.get('diagnosiApertura')!!.enable({ onlySelf: true })
            this.contattoForm.get('precedentiContatti')!!.enable({ onlySelf: true })
            this.contattoForm.get('inviante')!!.enable({ onlySelf: true })
          }

          if (this.contattoIsNew(this.contatto)) {
            this.contattoForm.get('dataApertura')?.valueChanges.subscribe(dt => {
              this.checkForDuplicateDates(dt)
            })
          }
          break;
        case "2":
          this.contattoForm.get('dataApertura')!!.disable({ onlySelf: true })
          this.contattoForm.get('diagnosiApertura')!!.disable({ onlySelf: true })
          this.contattoForm.get('precedentiContatti')!!.disable({ onlySelf: true })
          this.contattoForm.get('inviante')!!.disable({ onlySelf: true })
          break;
      }
    }
  }

  isAperturaFlagTerritorialeNo() {
    return this.aperturaFlag == "2"
  }

  cancellaContatto() {
    this.openChiudiContattoDialog('tutto')
  }

  cancellaVisibile(): Boolean {

    if (this.contatto!!.id != null && this.salvaVisibile() && this.tabShowed == TabShowedState.CONTATTI) {
      return true
    } else {
      return false
    }

  }

  dataChiusuraExist() {
    return this.chiusuraDataModel ? true : false
  }

  checkForDuplicateDates(date: NgbDateStruct) {
    let exist = this.listOfContattiNotAvailableDates.indexOf(JSON.stringify(date)) !== -1
    if (exist) {
      this.contattoForm.get('dataApertura')?.setErrors({ dateExist: true })
      //this.contattoForm.get('dataApertura')?.setValidators([Validators.required]);
      this.contattoForm.controls['dataApertura'].updateValueAndValidity({ onlySelf: true, emitEvent: false })
    } else {
      //this.contattoForm.get('dataApertura')?.setErrors({dateExist: null})
      this.contattoForm.get('dataApertura')?.setErrors(null)
      //this.contattoForm.get('dataApertura')?.setValidators([]);
      this.contattoForm.controls['dataApertura'].updateValueAndValidity({ onlySelf: true, emitEvent: false })
    }
  }


  observeForDataRefresh() {
    this.subscribe1 = this.sessionSevice.refreshData.subscribe(res => {
      if (res) {
        this.refreshContattoData()
        this.sessionSevice.setRefreshdata(false)
      }
    })
  }

  refreshContattoData() {
    this.apiService.selectContattoById(this.contatto.id!!).subscribe(res => {
      this.contatto = res
      this.sessionSevice.setSelectedContatto(this.contatto)
      this.loadListOfNotavailableDatesForContatti()
    })
  }

  gruppoAperturaHidden() {
    return this.aperturaFlag == null || this.aperturaFlag == "2";
  }

  chiusuraGroupHidden() {
    return this.contattoIsNew(this.contatto) || this.aperturaFlag == "2"
      || this.contatto.dataApertura == null;
  }

  isModalitaConclusioneRequired() {
    return this.chiusuraDataModel != null;
  }

  loadPresenze(contatto: Contatto) {
    this.apiService.getListaPresenze(contatto.id!!).subscribe({
      next: (res) => {
        this.listPresenze = res;
        this.sessionSevice.setListPresenze(this.listPresenze)
      },
      error: (err) => {
        console.error(err);
      },
      complete: () => {
      }
    })
  }

  presenzeExist() {
    return this.listPresenze!!.length != 0
  }

  contattoCanBeClosed() {
    if (this.isFormTerritoriale()) {
      return this.contatto.interventiList?.length != 0
        && this.contatto.diagnosiEScaleList?.length != 0
        && this.contatto.prestazioniList?.length != 0
    } else {
      return this.contatto.presenzaList?.length != 0
      // && this.contatto.prestazioniList?.length != 0 //FIX Per chiudere un contatto semires basta che ci sia almeno una presenza (togliere il controllo sulla prestazione) 21/02/2023 Mattia Ripanucci
    }
  }

  getMissingDataMessage() {

    let msg = ''

    if (this.sessionSevice.isSelectedStrutturaFromStorageTerritoriale()) {
      if (this.contatto.interventiList?.length == 0) {
        msg = "Nessun intervento trovato"
      } else if (this.contatto.diagnosiEScaleList?.length == 0) {
        msg = "Nessuna diagnosi&scale trovata"
      } else if (this.contatto.prestazioniList?.length == 0) {
        msg = "Nessuna prestazione trovata"
      }
    } else {
      if (this.contatto.presenzaList?.length == 0) {
        msg = "Il contatto non può essere chiuso se non sono registrate presenze"
      } else if (this.contatto.prestazioniList?.length == 0) {
        msg = "Nessuna prestazione trovata"
      }
    }

    return msg;

  }

  limitMaxDate() {
    let todayDate = this.sessionSevice.convertToDateStruct(new Date())
    this.maxDate = { year: todayDate?.year!!, month: todayDate?.month!!, day: todayDate?.day!! }
  }

  openChiudiContattoDialog(mode: string) {
    this.chiudiContattoMode = mode;
    this.modalService.open(this.chiudiContattoModal, { backdrop: 'static', keyboard: false });
  }

  chiudiAllContatto(id: number) {

    this.modalService.dismissAll()
    this.blockUI.start("Cancellazione in corso")
    this.apiService.chiudiContattoById(id, this.chiudiContattoMode).subscribe({
      next: (res) => {
        this.blockUI.stop()
        this.toastService.showSuccess("Cancellazione efettuata con successo")
        this.back()
      },
      error: (err) => {

        this.blockUI.stop()
        this.toastService.showSuccess("E successo un errore durante la cancellazione")
      },
      complete: () => {

      }
    })
  }

  alert(statoAttuale: ConfStato) {
    return new CommonsUtil().alert(statoAttuale);
  }

  async openchiudiContattoTerritoriale(content: any, form: FormGroup) {
    // reset stato conferma per evitare propagazioni indesiderate sui successivi salvataggi standard
    this.confermadiagnosichiusuraterritoriale = "";
    this.chiusuraTerritoriale = false;

    this.lastDiagnosiEScale = await this.getLastDiagnosiEScale();
    this.lastDiagnosiEScaleIcd10Descrizione = '';
    if (this.lastDiagnosiEScale?.diagnosiIcd10) {
      try {
        this.lastDiagnosiEScaleIcd10Descrizione = await this.getDiagnosiIcd10NameByCodice(this.lastDiagnosiEScale.diagnosiIcd10);
      } catch {
        this.lastDiagnosiEScaleIcd10Descrizione = '';
      }
    }
    const ldia = this.lastDiagnosiEScale;
    this.contatto.codiceDiagnosiChiusura = ldia ? ldia.diagnosi : '';
    this.contattoForm.get('diagnosiChiusura')?.patchValue(this.contatto.codiceDiagnosiChiusura);

    // Nella chiusura con conferma diagnosi il campo ICD10 non è editabile in modale:
    // valorizzo esplicitamente model+control per evitare invalidazione "diagnosiChiusuraIcd10 non valido".
    if (ldia?.diagnosiIcd10) {
      const diagIcd10 = new DiagnosiIcd10();
      diagIcd10.codice = ldia.diagnosiIcd10;
      diagIcd10.descrizione = this.lastDiagnosiEScaleIcd10Descrizione || await this.getDiagnosiIcd10NameByCodice(ldia.diagnosiIcd10);
      this.modelChiusuraDiagnosiIcd10 = diagIcd10;
      this.contattoForm.get('diagnosiChiusuraIcd10')?.setValue(diagIcd10, { emitEvent: false });
      this.contattoForm.get('diagnosiChiusuraIcd10')?.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    }

    const modalRef = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'xl' });
    //modalRef.componentInstance.form = form;

    modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;

      if (this.closeResult === 'Closed with: Back click') {
        this.back()
      }
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  openInterventoForm() {
    this.sessionSevice.setSelectedDiagnosiScale(JSON.stringify(new DiagnosiEScale()));
    this.router.navigate(['diagnosiescale-form'])
  }

  public async getLastDiagnosiEScale(): Promise<DiagnosiEScale> {
    const ldia = await lastValueFrom(this.apiService.getLatestDiagnosi4Contatto(this.contatto.id));
    return ldia;
  }

  chiusuraTerritoriale: boolean = false;

  async saveChiusuraTerritoriale(): Promise<boolean> {

    if (this.dataChiusuraExist()) {
      let maxDate = this.checkDateForCloseContact();
      maxDate = new Date(maxDate);
      let dd = this.contattoForm.get("dataChiusura")?.value;
      let ddd = new Date(dd.year, dd.month - 1, dd.day, 23, 59);
      if (maxDate.getTime() > ddd.getTime()) {
        this.toastService.showError('La data di chiusura non può essere precedente alle date degli interventi, diagnosi e/o prestazioni');
        return false;
      }
    }

    if (this.contattoForm.valid) {
      this.chiusuraTerritoriale = true;
      await this.submitForm(true);
      return true;
    } else {
      const controls = this.contattoForm.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          this.toastService.showError("Attenzione il valore " + name + " non è valido.");
          console.error(name);
        }
      }
      return false;
    }

  }

  canCloseTerriotriale() {
    return this.contatto.interventiList && this.contatto.interventiList?.length != 0 && this.contatto.diagnosiEScaleList && this.contatto.diagnosiEScaleList?.length != 0 && this.contatto.prestazioniList && this.contatto.prestazioniList?.length != 0;
  }

  prestazioniHasError() {
    return this.page.content.some(value => this.alert(value.statoAttuale));
  }

  setInterventiError(ev: boolean) {
    this.interventiError = ev;
  }

  setPresenzeError(ev: boolean) {
    this.presenzeError = ev;
  }

  setDiagnosiError(ev: boolean) {
    this.diagnosiError = ev;
  }

  public utente: Utente = new Utente();
  public OPERATORE_STRUTTURA: String = "operatore-struttura";
  public OPERATORE_ASL: String = "operatore-asl";
  public OPERATORE_DSM: String = "operatore-dsm";
  public OPERATORE_REGIONE: String = "operatore-regione";
  auditContatto: ContattoAudit[] = [];

  public getRuolo(ruolo: String) {
    this.getUtente();
    if (this.utente) {
      const nomeRuolo = (this.utente.nomeRuolo ?? '').toString();
      const target = (ruolo ?? '').toString();
      if (nomeRuolo === target || nomeRuolo.includes(target)) {
        return true;
      }
    }
    return false;
  }

  public getUtente() {
    var usr = sessionStorage.getItem("utente");
    if (usr != null && usr != undefined) {
      this.utente = JSON.parse(usr);
    }
  }

  private getSortedDiagnosiEScaleList(): DiagnosiEScale[] {
    const list = this.contatto?.diagnosiEScaleList ?? [];
    return [...list].sort((a, b) => {
      const ta = a?.data ? new Date(a.data as any).getTime() : 0;
      const tb = b?.data ? new Date(b.data as any).getTime() : 0;
      if (ta !== tb) return ta - tb;
      const ia = a?.id ?? 0;
      const ib = b?.id ?? 0;
      return ia - ib;
    });
  }

  private isDiagnosiDaModificare(ds: DiagnosiEScale | null | undefined): boolean {
    return (ds?.statoAttuale?.id ?? -1) === 0;
  }

  private getDiagnosiAperturaDs(): DiagnosiEScale | null {
    const list = this.getSortedDiagnosiEScaleList();
    return list.length > 0 ? list[0] : null;
  }

  private getDiagnosiChiusuraDs(): DiagnosiEScale | null {
    const list = this.getSortedDiagnosiEScaleList();
    return list.length > 0 ? list[list.length - 1] : null;
  }

  canEditDiagnosiApertura(): boolean {
    if (!this.hasWritePermission(this.mainUser)) {
      return false;
    }
    if (this.isAperturaFlagTerritorialeNo()) {
      return false;
    }
    // Edit consentito normalmente, oppure quando la diagnosi di apertura è stata marcata "Da modificare" (stato 0).
    return this.canEdit() || this.isDiagnosiDaModificare(this.getDiagnosiAperturaDs());
  }

  canEditDiagnosiChiusura(): boolean {
    if (!this.hasWritePermission(this.mainUser)) {
      return false;
    }
    // Edit consentito normalmente in fase di chiusura, oppure quando la diagnosi di chiusura è stata marcata "Da modificare" (stato 0).
    return this.canClose() || this.isDiagnosiDaModificare(this.getDiagnosiChiusuraDs());
  }

  openValidazioneDatiAsl() {
    if (!this.contatto || !this.contatto.id) {
      return;
    }

    const stato = this.contatto.statoAttuale?.id;
    if (stato == null || stato <= 1) {
      return;
    }

    const anno = this.getAnnoValidazioneDatiAsl();
    this.router.navigate(['dettaglio-dati-in-ingresso', this.contatto.id, String(stato), String(anno)]);
  }

  private getAnnoValidazioneDatiAsl(): number {
    const nowYear = new Date().getFullYear();

    const yearFromRichiesta = this.extractYear(this.contatto?.dataRichiesta);
    if (this.contatto?.aperturaFlag === '2' && yearFromRichiesta != null) {
      return yearFromRichiesta;
    }

    const yearFromChiusura = this.extractYear(this.contatto?.dataChiusura);
    if (yearFromChiusura != null) {
      return yearFromChiusura;
    }

    return nowYear;
  }

  private extractYear(value: unknown): number | null {
    if (!value) {
      return null;
    }

    const date = value instanceof Date ? value : new Date(value as any);
    if (Number.isNaN(date.getTime())) {
      return null;
    }

    return date.getFullYear();
  }

  async saveChiusuraTerritorialeAsync(modal: any) {
    await this.saveChiusuraTerritoriale() ? modal.dismiss() : null
  }

  changeDiagnosi(confermachangediagnosi: any, apertura: boolean) {
    if (this.contatto.tipoPrestazione == 'Territoriale') {

      if (this.contatto.id != null) {

        if (this.contatto.codiceDiagnosiApertura != null && this.contatto.codiceDiagnosiApertura != "") {

          if (apertura) {

            this.messagechangediagnosi = "La modifica della diagnosi di apertura produrrà la modifica della prima diagnosi in Diagnosi&scale";

          } else {

            this.messagechangediagnosi = "La modifica della diagnosi di chiusura produrrà l’inserimento della nuova diagnosi in Diagnosi&scale";

          }

          if (this.contatto.dataChiusura != null && this.contatto.diagnosiEScaleList?.length == 1 && this.contatto.codiceDiagnosiApertura != this.modelAperturaDiagnosi.codice) {
            // 0 this.contatto.codiceDiagnosiApertura == this.contatto.codiceDiagnosiChiusura && this.modelChiusuraDiagnosi.codice == this.contatto.codiceDiagnosiChiusura
            this.messagechangediagnosi = "La modifica della diagnosi di apertura produrrà a cascata sia la modifica della prima diagnosi che della diagnosi di conclusione, come da lei indicato in fase di conclusione del contatto. Se desidera invece modificare solo la diagnosi di apertura, ma non quella di conclusione, dovrà procedere per passi successivi: effettuare la modifica della diagnosi di apertura, che come detto le modifica entrambe (diagnosi apertura e diagnosi conclusione) modificare successivamente la sola diagnosi di chiusura, inserendo quella corretta";

          }

	          // chiude eventuali popup typeahead rimasti aperti dietro la modale
	          this.instance?.dismissPopup();
	          this.instanceChiusura?.dismissPopup();
	          // evita che il focus sull'input riapra subito i suggerimenti (ngbModal di default ripristina il focus)
	          try {
	            (document.activeElement as HTMLElement | null)?.blur();
	          } catch { }

	          this.modalService.open(confermachangediagnosi, {
	            ariaLabelledBy: 'modal-basic-title',
	            size: 'l',
	            scrollable: true,
	            centered: true,

	          }).result.then((result) => {
	            this.closeResult = `Closed with: ${result}`;
	            setTimeout(() => {
	              this.instance?.dismissPopup();
	              this.instanceChiusura?.dismissPopup();
	              try {
	                (document.activeElement as HTMLElement | null)?.blur();
	              } catch { }
	            }, 0);

	            if (this.closeResult === 'Closed with: Back click') {
	              this.back()
	            }
	          }, (reason) => {
	            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
	            setTimeout(() => {
	              this.instance?.dismissPopup();
	              this.instanceChiusura?.dismissPopup();
	              try {
	                (document.activeElement as HTMLElement | null)?.blur();
	              } catch { }
	            }, 0);
	          });
        }
      }
    }
  }

  // Modifiche MC
  /**
   *
   * FIX: la modifica della data di apertura/chiusura di un contatto territoriale può avere
   * impatti sui dati di diagnosi e interventi associati: se la data viene modificata
   * in modo da non essere più allineata con la data della diagnosi/intervento,
   * è necessario avvisare l'utente che si sta per modificare anche la data della
   * diagnosi/intervento stesso
   * (che rimane sempre allineata alla data di apertura/chiusura del contatto)
   * e chiedere conferma esplicita dell'operazione.
   *
   * @param confermachangediagnosi
   * @param isDataApertura
   * @returns
   */
  changeDataChiusuraDiagnosi(confermachangediagnosi: any, isDataApertura: boolean) {
    if (!this.shouldShowChangeDataChiusuraDiagnosiModal(isDataApertura)) {
      return;
    }

    if (isDataApertura) {
      this.messageChangeDataChiusuraDiagnosi = "La modifica della data di apertura comportera l'aggiornamento della data della prima diagnosi e del primo intervento associati al contatto";
    } else {
      this.messageChangeDataChiusuraDiagnosi = "La modifica della data di chiusura comportera l'aggiornamento della data dell'eventuale diagnosi associata se presente";
    }

    this.modalService.open(confermachangediagnosi, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'l',
      scrollable: true,
      centered: true,

    }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;

      if (this.closeResult === 'Closed with: Back click') {
        this.back()
      }
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private shouldShowChangeDataChiusuraDiagnosiModal(isDataApertura: boolean): boolean {
    // Mostra la modale solo in vera fase di edit su contatti territoriali.
    if (this.contatto?.tipoPrestazione !== 'Territoriale' ) {
      return false;
    }
    if (!this.contatto?.id) {
      return false;
    }

    const oldDateRaw = isDataApertura ? this.contatto.dataApertura : this.contatto.dataChiusura;
    if (!oldDateRaw) {
      return false;
    }

    const newDateModel = isDataApertura ? this.aperturaDataModel : this.chiusuraDataModel;
    const newDate = this.sessionSevice.toNativeDate(newDateModel ?? null);
    if (!newDate) {
      return false;
    }

    const oldDate = new Date(oldDateRaw as any);
    if (Number.isNaN(oldDate.getTime())) {
      return false;
    }
    if (this.sameCalendarDay(oldDate, newDate)) {
      return false;
    }

    const diagnosiHasImpact = this.hasEntityOnDate(this.contatto.diagnosiEScaleList as any[], oldDate);
    const interventiHasImpact = this.hasEntityOnDate(this.contatto.interventiList as any[], oldDate);
    return diagnosiHasImpact || interventiHasImpact;
  }

  private hasEntityOnDate(list: any[] | undefined, date: Date): boolean {
    if (!list || list.length === 0) {
      return false;
    }

    return list.some(item => {
      const itemDate = item?.data ? new Date(item.data as any) : null;
      return itemDate != null && !Number.isNaN(itemDate.getTime()) && this.sameCalendarDay(itemDate, date);
    });
  }

  private sameCalendarDay(a: Date, b: Date): boolean {
    return a.getFullYear() === b.getFullYear()
      && a.getMonth() === b.getMonth()
      && a.getDate() === b.getDate();
  }

  /**
   * [ADEGUAMENTO-ICD10][#40]
   * FIX: gestione robusta della conversione a Date, con fallback a
   * null in caso di valore non convertibile
   * (es. stringa non in formato data, ecc.)
   *
   * @lastUpdate 2026-02-26 - AMS
   *
   */
  private toValidDate(value: any): Date | null {
    if (!value) {
      return null;
    }
    const d = value instanceof Date ? value : new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  }


  protected readonly CommonsUtil = CommonsUtil;
  storicoList: any;
  storicoTitle: any;

  async openStoricoContatti(audit: any) {
    if (this.tabShowed == TabShowedState.INTERVENTI) {
      this.storicoTitle = "Storico interventi";
      this.apiService.getStoricoInterventoTerritoriale(this.contatto.id!).subscribe(res => {
        if (res) {
          this.storicoList = res;
        }
      });
    } else if (this.tabShowed == TabShowedState.DIAGNOSISCALE) {
      this.storicoTitle = "Storico diagnosi & scale";
      this.apiService.getStoricoDiagnosiEScaleTerritoriale(this.contatto.id!).subscribe(res => {
        if (res) {
          this.storicoList = res;
        }
      });
    } else if (this.tabShowed == TabShowedState.PRESENZE) {
      this.storicoTitle = "Storico presenze";
      this.apiService.getStoricoPresenzeSemiresidenziale(this.contatto.id!).subscribe(res => {
        if (res) {
          this.storicoList = res;
        }
      });
    } else if (this.tabShowed == TabShowedState.PRESTAZIONI) {
      this.storicoTitle = "Storico prestazioni";
      if (this.isTipoPrestazioneTerritoriale()) {
        this.apiService.getStoricoPrestazioneTerritoriale(this.contatto.id!).subscribe(res => {
          if (res) {
            this.storicoList = res;
          }
        });
      } else {
        this.apiService.getStoricoPrestazioneSemiresidenziale(this.contatto.id!).subscribe(res => {
          if (res) {
            this.storicoList = res;
          }
        });
      }
    } else if (this.tabShowed == TabShowedState.CONTATTI) {
      this.storicoTitle = "Storico contatto";
      if (this.isTipoPrestazioneTerritoriale()) {
        this.apiService.getStoricoSingoloContattoTerritoriale(this.contatto.id!).subscribe(res => {
          if (res) {
            this.storicoList = res;
          }
        });
      } else {
        this.apiService.getStoricoSingoloContattoSemiresidenziale(this.contatto.id!).subscribe(res => {
          if (res) {
            this.storicoList = res;
          }
        });
      }
    } else {

    }
    this.modalService.open(audit, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'xl',
      windowClass: "sismModal",
      scrollable: true
    }).result.then((result) => {
    }, (reason) => {
    });

  }

  getLabelTab() {
    if (this.tabShowed == TabShowedState.CONTATTI) {
      return "contatto";
    } else if (this.tabShowed == TabShowedState.PRESTAZIONI) {
      return "prestazioni";
    } else if (this.tabShowed == TabShowedState.INTERVENTI) {
      return "interventi";
    } else if (this.tabShowed == TabShowedState.DIAGNOSISCALE) {
      return "diagnosi&scale";
    } else if (this.tabShowed == TabShowedState.PRESENZE) {
      return "presenze";
    } else if (this.tabShowed == TabShowedState.ANAGRAFICA) {
      return "anagrafica";
    } else {
      return "";
    }
  }

  isEdit: boolean = false;

  edit() {
    this.isEdit = !this.isEdit;
  }

  editVisibile() {
    return this.tabShowed == TabShowedState.ANAGRAFICA && !this.isValidato() && this.getRuolo(this.OPERATORE_STRUTTURA);
  }

  async salvaAnagrafica() {
    const salvato = await this.appStoricoAnagraficaEdit?.salva();
    if (salvato) {
      this.isEdit = false;
      this.toastService.showSuccess('I dati anagrafici sono stati aggiornati correttamente.');

    } else {
      this.toastService.showError('Attenzione si è verificato un errore e non è stato possibile effettuare il salvataggio');

    }
  }

  getDescrizioneASL(codiceAslOperatoreInserimento: string | undefined) {
    return this.aslList.find(value => value.codiceAzienda == codiceAslOperatoreInserimento)?.denominazioneAzienda;
  }

  async getDiagnosiIcd10NameByCodice(codice: string): Promise<string> {
    if (!codice) return '';
    try {
      const res = await lastValueFrom(this.apiService.getDiagnosiIcd10ById(codice));
      return res?.descrizione ?? '';
    } catch (error) {
      console.error('Errore recupero diagnosi ICD10:', error);
      return '';
    }
  }
}



